const messages = {
  pt: {
    translations: {
      appointments: {
        menu: {
          calendar: 'Calendário',
        },
        tooltip: {
          details: 'Detalhes',
          busyHint: 'Horário ocupado por um evento do Google Agenda. Os detalhes do evento não são exibidos.',
        },
        grid: {
          title: 'Selecione um horário',
          chooseType: 'Escolha o tipo de atendimento para ver os horários livres.',
          previousMonth: 'Mês anterior',
          nextMonth: 'Próximo mês',
          previousWeek: 'Semana anterior',
          nextWeek: 'Próxima semana',
          freeDaysHint: 'Dias em destaque têm horário livre.',
          noWeekSlots: 'Nenhum horário livre nesta semana. Use as setas ou escolha outro dia no mês.',
          changeTime: 'Trocar horário',
          sideBySide: 'Lado a lado',
        },
        phase6: {
          myAgenda: 'Minha agenda: {{name}}',
          connectedAs: 'Google conectado: {{email}}',
          clinicFallback: 'Sem Google próprio; vale a agenda da clínica.',
          connectOwnGoogle: 'Conectar meu Google',
          reconnectOwnGoogle: 'Reconectar meu Google',
          disconnectOwnGoogle: 'Desconectar Google próprio',
          connectOwnGoogleHint: 'O próprio profissional conecta o Google na tela da Agenda dele.',
          myGoogleCalendar: 'Minha agenda do Google',
          disconnectTitle: 'Desconectar o Google',
          disconnectMessage: 'Os eventos já criados no Google permanecem lá. Desconectar esta conta?',
          accessUser: 'Usuário de acesso',
          noAccessUser: 'Sem acesso próprio',
          ownHours: 'Horário de funcionamento próprio',
          hoursHint: 'Sem horário próprio, vale o horário da clínica. Com horário próprio, dias sem período ficam fechados. Em cada dia, informe início e fim do primeiro período e, se necessário, do segundo.',
          firstPeriod: 'Primeiro período',
          secondPeriod: 'Segundo período',
          start: 'início',
          end: 'fim',
          noClinicCalendar: 'Sem agenda da clínica',
          changeProfessional: 'Trocar profissional',
          saveChange: 'Salvar troca',
          professionalChanged: 'Profissional alterado.',
          professionalChangedTo: 'Profissional alterado para {{name}}',
        },
        reports: {
          title: 'Relatórios da Agenda',
          subtitle: 'Acompanhe confirmações, faltas, cancelamentos e o uso da IA no período escolhido.',
          lastDays: 'Últimos {{days}} dias',
          from: 'De',
          to: 'Até',
          invalidPeriod: 'Escolha um período de 1 a 366 dias.',
          note: 'Considera os agendamentos que começam no período.',
          total: 'Agendamentos',
          confirmationRate: 'Taxa de confirmação',
          confirmedCount: '{{count}} confirmados',
          noShowRate: 'Taxa de faltas',
          noShowHint: 'Entre os que já tiveram resultado',
          cancellations: 'Cancelamentos',
          reschedules: 'Reagendamentos',
          byAi: '{{count}} pela IA',
          byStatus: 'Por status',
          cancellationsByOrigin: 'Cancelamentos por origem',
          reschedulesByOrigin: 'Reagendamentos por origem',
          byProfessional: 'Por profissional',
          byType: 'Por tipo de atendimento',
          clinicCalendar: 'Agenda da clínica',
          noType: 'Sem tipo',
          aiUsage: 'Uso da IA no período',
          repliesRead: 'Respostas lidas',
          modelCalls: 'Chamadas ao modelo',
          tokens: 'Tokens',
          failures: 'Falhas',
          empty: 'Nenhum registro no período.',
          name: 'Nome',
          attended: 'Compareceram',
          noShows: 'Faltas',
          cancelled: 'Cancelados',
          origins: {
            user: 'Atendente',
            whatsapp: 'Cliente (WhatsApp)',
            ai: 'IA',
            google: 'Google Agenda',
            system: 'Sistema',
          },
        },
        notifications: {
          tab: 'Notificações',
          intro: 'O sistema avisa o cliente por WhatsApp, entende a resposta (confirmar, cancelar ou reagendar) e atualiza o agendamento.',
          connection: 'Conexão WhatsApp das notificações',
          off: 'Desligadas',
          handoffQueue: 'Fila dos atendimentos entregues a uma pessoa',
          noQueue: 'Nenhuma (mantém a fila atual)',
          reminders: 'Lembretes automáticos',
          daysBefore: '{{amount}} dia(s) antes',
          hoursBefore: '{{amount}} hora(s) antes',
          minutesBefore: '{{amount}} minutos antes',
          messages: 'Mensagens',
          variables: 'Variáveis',
          variablesHint: 'Clique em uma variável para copiá-la e cole no texto da mensagem. No envio, ela é trocada pelo dado do agendamento.',
          variableCopied: '{{variable}} copiada.',
          copyFailed: 'Não foi possível copiar. Selecione e copie a variável manualmente.',
          copyVariable: 'Copiar {{variable}}',
          variableDescriptions: {
            nome: 'Nome do contato',
            data: 'Data do agendamento',
            hora: 'Horário do agendamento',
            tipo: 'Tipo de atendimento',
            empresa: 'Nome da empresa',
            opcoes: 'Lista numerada: horários ao reagendar ou agendamentos para escolher',
          },
          restoreDefault: 'Restaurar padrão',
          sending: 'Envio',
          preview: 'Prévia no WhatsApp',
          customized: 'Personalizada',
          groups: {
            request: 'Pedidos de resposta',
            replies: 'Respostas ao cliente',
            reschedule: 'Reagendamento com IA',
          },
          notifyOnCreate: 'Enviar confirmação por WhatsApp',
          notifyCustomer: 'Avisar o cliente por WhatsApp',
          sent: 'Enviado por WhatsApp: {{notification}}',
          sendFailed: 'Não foi possível enviar por WhatsApp: {{notification}}',
          notes: {
            max_rounds: 'Entregue a um atendente: nenhum horário foi aceito',
            no_slots: 'Entregue a um atendente: sem horários livres',
            handoff: 'Entregue a um atendente',
            taken_over: 'Conversa assumida por um atendente',
          },
          conversation: 'Conversa por WhatsApp',
          resend: 'Reenviar notificação',
          resent: 'Notificação enviada.',
          takeOver: 'Assumir conversa',
          tookOver: 'Conversa assumida.',
          kinds: {
            reschedulePreference: 'Reagendar: pergunta do melhor dia',
            rescheduleOptions: 'Reagendar: horários oferecidos',
            rescheduleDone: 'Reagendar: horário remarcado',
            noSlots: 'Reagendar: sem horários livres',
            whichAppointment: 'Pergunta de qual agendamento',
            confirmationRequest: 'Pedido de confirmação',
            reminder: 'Lembrete',
            rescheduled: 'Aviso de novo horário',
            confirmed: 'Confirmação',
            cancelled: 'Aviso de cancelamento',
            cancelQuestion: 'Pergunta de cancelamento',
            cancelKept: 'Aviso de horário mantido',
            unclear: 'Pedido para repetir a resposta',
            handoff: 'Aviso de atendimento humano',
          },
          stages: {
            reschedule_collect: 'Reagendando com a IA: aguardando o dia preferido',
            reschedule_choose: 'Reagendando com a IA: aguardando a escolha do horário',
            awaiting_reply: 'Aguardando resposta do cliente',
            awaiting_cancel_confirmation: 'Aguardando a confirmação do cancelamento',
            handed_off: 'Com um atendente',
            done: 'Conversa concluída',
            expired: 'Conversa encerrada sem resposta',
          },
          intents: {
            confirm: 'Confirmar',
            cancel: 'Cancelar',
            reschedule: 'Reagendar',
            question: 'Dúvida',
            handoff: 'Falar com um atendente',
            unclear: 'Não entendida',
          },
          noReplies: 'O cliente ainda não respondeu.',
          readings: {
            number: 'Resposta pelo número da opção',
            keyword: 'Identificada por palavra-chave',
            ai: 'Interpretada pela IA',
            fallback: 'Não foi possível entender',
          },
          sources: {
            number: 'Número',
            keyword: 'Palavra',
            ai: 'IA',
            fallback: 'Não entendida',
          },
        },
        ai: {
          rescheduleEnable: 'Reagendar com IA',
          rescheduleHint: 'Quando o cliente pede para reagendar, o sistema pergunta o melhor dia, oferece horários livres e conclui a troca. Sem isso, um atendente assume.',
          searchDays: 'Procurar horários nos próximos (dias)',
          minNotice: 'Antecedência mínima (horas)',
          optionsCount: 'Horários oferecidos por vez',
          maxRounds: 'Máximo de listas antes de chamar um atendente',
          tab: 'Respostas e IA',
          intro: 'As respostas "1", "2" e "3" são entendidas sempre. Com a IA ligada, o sistema também entende frases livres, como "pode ser sim, mas vou chegar um pouco atrasado".',
          enable: 'Entender respostas em texto livre com IA',
          notConfigured: 'A IA ainda não foi configurada neste ambiente. Fale com o administrador do sistema.',
          debounce: 'Esperar por mensagens seguidas (segundos)',
          debounceHint: 'Se o cliente mandar mais de uma mensagem, o sistema espera esse tempo e lê tudo como uma resposta só.',
          testTitle: 'Testar interpretação',
          testHint: 'Digite uma resposta de cliente e veja como o sistema a entenderia. O teste usa a IA mesmo com ela desligada acima.',
          customerReply: 'Resposta do cliente',
          simulateCancelQuestion: 'Simular a resposta à pergunta "Confirma o cancelamento?"',
          test: 'Testar',
          understood: 'Entendeu',
          unreachable: 'Não foi possível consultar a IA.',
          usageTitle: 'Consumo nos últimos 30 dias',
          usageSummary: '{{replies}} respostas lidas, {{calls}} consultas à IA, {{tokens}} tokens, {{errors}} falhas.',
        },
        google: {
          tab: 'Google Agenda',
          intro: 'Opcional. Com uma agenda do Google conectada, cada agendamento vira um evento nela e os eventos que já estão lá bloqueiam o horário no sistema.',
          notConfigured: 'A integração com o Google Agenda ainda não foi configurada neste ambiente. Fale com o administrador do sistema.',
          revokedHint: 'Novos agendamentos continuam sendo criados e serão enviados ao Google depois que você reconectar.',
          connect: 'Conectar com o Google',
          reconnect: 'Reconectar com o Google',
          connectedToast: 'Conta do Google conectada. Escolha a agenda que será usada.',
          connectErrorToast: 'Não foi possível conectar com o Google. Tente novamente.',
          connectedAs: 'Conectado como',
          calendar: 'Agenda',
          lastSync: 'Última sincronização',
          syncNow: 'Sincronizar agora',
          synced: 'Sincronização concluída.',
          changeCalendar: 'Trocar de agenda',
          disconnect: 'Desconectar',
          disconnected: 'Google Agenda desconectado.',
          disconnectTitle: 'Desconectar o Google Agenda',
          disconnectMessage: 'Os agendamentos continuam no sistema e os eventos já criados no Google não são apagados. Os horários ocupados importados deixam de bloquear a agenda.',
          calendarLabel: 'Agenda do Google',
          primary: 'principal',
          noCalendars: 'Nenhuma agenda com permissão de edição foi encontrada nesta conta.',
          syncExisting: 'Enviar para o Google os agendamentos futuros que já existem',
          useCalendar: 'Usar esta agenda',
          calendarConnected: 'Agenda do Google conectada.',
          busy: 'Ocupado (Google Agenda)',
          fieldShare: 'Enviar para a descrição do Google Agenda',
          fieldShareHint: 'O valor deste campo aparece na descrição do evento. Evite dados sensíveis.',
          blockAllDay: 'Eventos de dia inteiro do Google bloqueiam o horário',
          syncStatus: {
            synced: 'Sincronizado com o Google Agenda',
            pending: 'Enviando para o Google Agenda…',
            error: 'Não foi possível sincronizar com o Google Agenda',
            retry: 'Tentar novamente',
          },
        },
        title: 'Agenda',
        minutes: '{{minutes}} min',
        yes: 'Sim',
        buttons: {
          reports: 'Relatórios',
          add: 'Novo agendamento',
          create: 'Adicionar',
          settings: 'Configurações',
          schedule: 'Agendar',
          cancel: 'Cancelar',
          back: 'Voltar',
          confirm: 'Confirmar',
          reschedule: 'Reagendar',
          attended: 'Compareceu',
          noShow: 'Faltou',
          cancelAppointment: 'Cancelar agendamento',
          reactivate: 'Reativar',
          save: 'Salvar',
        },
        filters: {
          professional: 'Profissional',
          allProfessionals: 'Todos os profissionais',
          status: 'Status',
          allStatuses: 'Todos os status',
          allTypes: 'Todos os tipos',
        },
        status: {
          pending_confirmation: 'Aguardando confirmação',
          confirmed: 'Confirmado',
          reschedule_requested: 'Reagendamento solicitado',
          cancelled: 'Cancelado',
          completed: 'Compareceu',
          no_show: 'Faltou',
        },
        origin: {
          user: 'Usuário',
          whatsapp: 'Cliente (WhatsApp)',
          ai: 'IA',
          google: 'Google Agenda',
          system: 'Sistema',
        },
        calendar: {
          date: 'Data',
          time: 'Hora',
          event: 'Agendamento',
          allDay: 'Dia todo',
          week: 'Semana',
          day: 'Dia',
          month: 'Mês',
          previous: 'Anterior',
          next: 'Próximo',
          today: 'Hoje',
          agenda: 'Lista',
          noEvents: 'Não há agendamentos no período.',
        },
        contact: {
          title: 'Agenda',
          upcoming: 'Hoje e próximos',
          upcomingTitle: 'Próximos agendamentos',
          history: 'Histórico dos últimos 90 dias',
          historyEmpty: 'Nenhum outro agendamento nos últimos 90 dias.',
          empty: 'Este contato não tem agendamento marcado.',
          schedule: 'Agendar',
          newAppointment: 'Novo agendamento',
          nextAppointment: 'Próximo agendamento: {{when}}',
          loadHistory: 'Carregar histórico',
          hideHistory: 'Ocultar histórico',
          today: 'Hoje',
          tomorrow: 'Amanhã',
          yesterday: 'Ontem',
          close: 'Fechar',
        },
        modal: {
          addTitle: 'Novo agendamento',
        },
        form: {
          professional: 'Profissional',
          selectProfessional: 'Selecione o profissional',
          contact: 'Contato',
          contactHelp: 'Digite ao menos 3 letras para buscar',
          contactPrefilled: 'Preenchido a partir do atendimento. Dá para trocar, se precisar.',
          addContact: 'Adicionar',
          type: 'Tipo de atendimento',
          date: 'Data',
          time: 'Horário',
          noSlots: 'Nenhum horário livre neste dia. Verifique o horário de funcionamento da empresa ou escolha outra data.',
          notes: 'Observações',
        },
        reschedule: {
          title: 'Reagendar',
          hint: 'Depois de reagendar, o agendamento volta para "Aguardando confirmação".',
        },
        reactivate: {
          title: 'Reativar agendamento',
          hint: 'O agendamento volta no mesmo horário, aguardando a confirmação do cliente. Para outro horário, reative e depois reagende.',
          note: 'Motivo (opcional)',
          notify: 'Pedir a confirmação ao cliente por WhatsApp',
        },
        cancel: {
          title: 'Cancelar agendamento',
          reason: 'Motivo (opcional)',
        },
        drawer: {
          professional: 'Profissional',
          status: 'Status',
          dateTime: 'Data e horário',
          scheduledBy: 'Agendado por',
          cancelReason: 'Motivo do cancelamento',
          history: 'Histórico',
          rescheduledFromTo: 'Reagendado de {{from}} para {{to}}',
        },
        toasts: {
          created: 'Agendamento criado com sucesso.',
          rescheduled: 'Agendamento reagendado com sucesso.',
          cancelled: 'Agendamento cancelado.',
          statusUpdated: 'Status atualizado.',
          reactivated: 'Agendamento reativado.',
        },
        settings: {
          professionals: {
            intro: 'Opcional. Cadastre os profissionais que atendem para que cada um tenha a própria agenda. Com algum profissional ativo, todo agendamento precisa de um profissional.',
            add: 'Novo profissional',
            empty: 'Nenhum profissional cadastrado. A agenda segue única, sem escolher um profissional.',
            name: 'Nome',
            googleCalendar: 'Agenda do Google',
            googleHelp: 'Sem agenda própria, os agendamentos seguem a agenda da clínica quando ela existe.',
            noGoogleCalendar: 'Seguir agenda da clínica',
            systemOnly: 'Agenda da clínica ou só no sistema',
            addTitle: 'Novo profissional',
            editTitle: 'Editar profissional',
            deleteTitle: 'Excluir profissional',
            deleteMessage: 'Deseja excluir o profissional "{{name}}"? Profissionais com agendamentos não podem ser excluídos; desative-os.',
            deleted: 'Profissional excluído com sucesso.',
            saved: 'Profissional salvo com sucesso.',
          },
          title: 'Configurações da Agenda',
          subtitle: 'Defina como a agenda funciona: tipos de atendimento, profissionais, campos, integrações, notificações e regras.',
          active: 'Ativo',
          inactive: 'Inativo',
          actions: 'Ações',
          tabs: {
            professionals: 'Profissionais',
            types: 'Tipos de atendimento',
            fields: 'Campos',
            rules: 'Regras',
          },
          types: {
            intro: 'Defina os tipos de atendimento, como consulta, retorno ou avaliação, e a duração de cada um.',
            add: 'Novo tipo',
            empty: 'Nenhum tipo de atendimento cadastrado. Crie ao menos um para poder agendar.',
            name: 'Nome',
            duration: 'Duração (minutos)',
            durationShort: 'Duração',
            durationOptions: {
              minutes: '{{minutes}} minutos',
              hour: '1 hora',
              hours: '{{hours}} horas',
              hoursMinutes: '{{hours}}h{{minutes}}',
              custom: 'Personalizado',
              customHelp: 'Informe de 5 a 480 minutos.',
            },
            color: 'Cor',
            addTitle: 'Novo tipo de atendimento',
            editTitle: 'Editar tipo de atendimento',
            deleteTitle: 'Excluir tipo de atendimento',
            deleteMessage: 'Deseja excluir o tipo "{{name}}"? Tipos já usados em agendamentos não podem ser excluídos; desative-os.',
            saved: 'Tipo de atendimento salvo com sucesso.',
            deleted: 'Tipo de atendimento excluído com sucesso.',
          },
          fields: {
            intro: 'Além do contato, estes campos são preenchidos em cada agendamento. Use as setas para mudar a ordem.',
            add: 'Novo campo',
            empty: 'Nenhum campo adicional cadastrado.',
            label: 'Nome do campo',
            type: 'Tipo',
            options: 'Opções (uma por linha)',
            required: 'Obrigatório',
            addTitle: 'Novo campo',
            editTitle: 'Editar campo',
            deleteTitle: 'Excluir campo',
            deleteMessage: 'Deseja excluir o campo "{{name}}"? Os agendamentos já criados mantêm o valor preenchido.',
            saved: 'Campo salvo com sucesso.',
            deleted: 'Campo excluído com sucesso.',
            moveUp: 'Mover para cima',
            moveDown: 'Mover para baixo',
            types: {
              text: 'Texto curto',
              textarea: 'Texto longo',
              number: 'Número',
              date: 'Data',
              select: 'Lista de opções',
              checkbox: 'Caixa de seleção',
            },
          },
          rules: {
            slotInterval: 'Intervalo entre horários (minutos)',
            defaultDuration: 'Duração padrão de novos tipos (minutos)',
            hint: 'Os horários livres seguem o horário de funcionamento da empresa, configurado em Configurações.',
            saved: 'Configurações salvas com sucesso.',
          },
        },
      },
      fiscalData: {
        title: 'Dados fiscais',
        intro: 'Para emitir a nota fiscal, precisamos da razão social (ou do nome completo) e do endereço. Preencha uma vez e continue o pagamento.',
        legalName: 'Razão social',
        legalNameHelp: 'Nome empresarial registrado no CNPJ, não o nome fantasia.',
        fullName: 'Nome completo',
        fullNameHelp: 'Como consta no CPF.',
        postalCode: 'CEP',
        zipcodeLookup: 'Informe um CEP válido para localizar o município.',
        checkingZipcode: 'Consultando CEP...',
        street: 'Logradouro',
        number: 'Número',
        complement: 'Complemento',
        district: 'Bairro',
        city: 'Cidade / UF',
        required: 'Obrigatório',
        help: 'Esses dados são usados apenas na emissão da nota fiscal.',
        save: 'Salvar dados fiscais',
        saving: 'Salvando...',
        saved: 'Dados fiscais salvos.',
        checking: 'Verificando dados fiscais...',
      },
      notavoa: {
        title: 'Nota fiscal — Notavoa',
        activationHelp:
          'A emissão começa após a ativação. A data de competência de cada nota é a data do pagamento da fatura; ' +
          'confirme com sua contabilidade antes de habilitar. Município, regime tributário e ISS seguem o cadastro do emissor na Notavoa.',
        loading: 'Carregando configuração fiscal...',
        clientId: 'Client ID',
        clientSecret: 'Client secret',
        secretConfigured: 'Secret configurado. Deixe vazio para manter.',
        secretMissing: 'Secret ainda não configurado.',
        issuer: 'Emissor',
        issuerHelp: 'Salve o Client ID e o secret para listar os emissores.',
        environment: 'Ambiente',
        PRODUCTION: 'Produção',
        HOMOLOGATION: 'Homologação',
        nationalTaxCode: 'Código nacional do serviço',
        nationalTaxCodeHelp: 'Busque pelo nome ou digite o código de 6 dígitos. É preciso salvar as credenciais para listar os serviços.',
        suggested: 'sugerido',
        optionalFields: 'Campos opcionais',
        optionalFieldsHelp: 'Preencha somente se a contabilidade ou a SEFIN exigir. Em branco, esses dados não são enviados.',
        municipalTaxCode: 'Código de tributação municipal',
        municipalTaxCodeHelp: '3 dígitos (cTribMun), exigido por alguns municípios.',
        nbsCode: 'Código NBS',
        nbsCodeHelp: '9 dígitos, sem pontos.',
        issRate: 'Alíquota do ISS (%)',
        issRateHelp: 'Somente para município fora do sistema nacional. Ex.: 2,00.',
        pisCofinsCst: 'CST de PIS/COFINS',
        pisCofinsCstHelp: '2 dígitos, ex.: 01. Costuma ser necessário fora do Simples Nacional.',
        simplesNacionalRate: 'Alíquota do Simples Nacional (%)',
        simplesNacionalRateHelp: 'Obrigatória para emissor ME/EPP. Informe a alíquota efetiva total do Simples, como 6,00, conforme sua contabilidade.',
        serviceDescription: 'Descrição do serviço',
        enabled: 'Habilitar emissão automática',
        save: 'Salvar configuração',
        validate: 'Validar conexão',
        saved: 'Configuração fiscal salva.',
        valid: 'Conexão e emissor válidos.',
        fiscalNote: 'Nota fiscal',
        noNote: 'Sem nota fiscal',
        pending: 'Pagamento confirmado — aguardando nota',
        blocked: 'Nota bloqueada: dados fiscais incompletos',
        unknown: 'Consultando emissão',
        submitted: 'Aguardando emissão',
        conflict: 'Emissão bloqueada: contate o suporte',
        QUEUED: 'Aguardando emissão',
        PROCESSING: 'Emitindo nota',
        AUTHORIZED: 'Nota emitida',
        REJECTED: 'Nota rejeitada',
        FAILED: 'Falha na emissão',
        CANCELLING: 'Em cancelamento',
        CANCELLED: 'Nota cancelada',
        downloadPdf: 'Baixar PDF',
        downloadXml: 'Baixar XML',
        invoicesTitle: 'Emissão manual de notas',
        invoicesHelp:
          'Faturas pagas de todas as empresas. Emita notas de pagamentos anteriores, tente novamente quando a emissão ficou bloqueada ' +
          'ou reprocesse notas rejeitadas ou com falha. No reprocessamento, os dados são refeitos com a configuração atual.',
        invoice: 'Fatura',
        company: 'Empresa',
        value: 'Valor',
        issueNote: 'Emitir nota',
        retryIssue: 'Tentar novamente',
        reprocess: 'Reprocessar',
        issueRequested: 'Emissão solicitada.',
        noPaidInvoices: 'Nenhuma fatura paga encontrada.',
        loadMore: 'Carregar mais',
      },
      signup: {
        title: 'Cadastre-se',
        toasts: {
          success: 'Usuário criado com sucesso! Faça seu login!!!.',
          fail: 'Erro ao criar usuário. Verifique os dados informados.',
        },
        form: {
          name: 'Nome',
          email: 'Email',
          password: 'Senha',
        },
        buttons: {
          submit: 'Cadastrar',
          login: 'Já tem uma conta? Entre!',
        },
      },
      login: {
        title: 'Login',
        form: {
          email: 'Email',
          password: 'Senha',
        },
        buttons: {
          submit: 'Entrar',
          register: 'Registre-se, agora mesmo!',
        },
      },
      plans: {
        form: {
          name: 'Nome',
          users: 'Usuários',
          connections: 'Conexões',
          campaigns: 'Campanhas',
          schedules: 'Agendamentos',
          crm: 'CRM',
          enabled: 'Habilitadas',
          disabled: 'Desabilitadas',
          clear: 'Cancelar',
          delete: 'Excluir',
          save: 'Salvar',
          yes: 'Sim',
          no: 'Não',
          money: 'R$',
        },
      },
      companies: {
        title: 'Cadastrar Empresa',
        form: {
          name: 'Nome da Empresa',
          plan: 'Plano',
          token: 'Token',
          submit: 'Cadastrar',
          success: 'Empresa criada com sucesso!',
        },
      },
      auth: {
        toasts: {
          success: 'Login efetuado com sucesso!',
        },
        token: 'Token',
      },
      dashboard: {
        charts: {
          ticketsCreated: 'Atendimentos Criados: ',
          tickets: 'Tickets',
          perDay: {
            title: 'Atendimentos hoje: ',
          },
        },
        filters: {
          dateFrom: 'Data Inicial',
          dateTo: 'Data Final',
          period: 'Periodo',
          noneSelected: 'Nenhum selecionado',
          last3Days: 'Ultimos 3 dias',
          last7Days: 'Ultimos 7 dias',
          last15Days: 'Ultimos 15 dias',
          last30Days: 'Ultimos 30 dias',
          last60Days: 'Ultimos 60 dias',
          last90Days: 'Ultimos 90 dias',
          filterType: 'Tipo de Filtro',
          dateFilter: 'Filtro por Data',
          periodFilter: 'Filtro por Periodo',
          filter: 'Filtrar',
        },
        cards: {
          activeConnections: 'Conexoes Ativas',
          companies: 'Empresas',
          inConversation: 'Em Conversa',
          waiting: 'Aguardando',
          newContacts: 'Novos Contatos',
          avgConversationTime: 'T.M. de Conversa',
          finished: 'Finalizados',
          avgWaitTime: 'T.M. de Espera',
        },
        messages: {
          parameterizeFilter: 'Parametrize o filtro',
        },
        awaitingResponse: {
          title: 'Tickets sem resposta',
          subtitle: 'Backlog atual com última mensagem do contato no período filtrado.',
          chartTitle: 'Evolução diária de tickets sem resposta',
          open: 'Aberto',
          pending: 'Pendente',
          empty: 'Nenhum ticket sem resposta encontrado para o período selecionado.',
        },
        userRatings: {
          title: 'Atendimentos avaliados - {{name}}',
          subtitle: 'Avaliações recebidas no período filtrado no dashboard.',
          openRatings: 'Ver atendimentos avaliados',
          contact: 'Contato',
          queue: 'Fila',
          rate: 'Nota',
          ratedAt: 'Avaliado em',
          viewMessages: 'Ver mensagens',
          empty: 'Nenhum atendimento avaliado no período filtrado.',
          noQueue: 'Sem fila',
          close: 'Fechar',
        },
      },
      connections: {
        title: 'Conexões',
        subtitle: "Todos os WhatsApp's",
        toasts: {
          deleted: 'Conexão com o WhatsApp excluída com sucesso!',
          disconnected: 'Sessão do WhatsApp desconectada com sucesso.',
          connecting: 'Iniciando sessão do WhatsApp. Aguarde o QR Code.',
          requestingQr: 'Solicitando um novo QR Code. Aguarde a atualização.',
        },
        confirmationModal: {
          deleteTitle: 'Deletar',
          deleteMessage: 'Você tem certeza? Essa ação não pode ser revertida.',
          disconnectTitle: 'Desconectar',
          disconnectMessage: 'Tem certeza? Você precisará ler o QR Code novamente.',
        },
        buttons: {
          add: 'Adicionar WhatsApp',
          disconnect: 'desconectar',
          tryAgain: 'Tentar novamente',
          qrcode: 'QR CODE',
          newQr: 'Novo QR CODE',
          pairingCode: 'Código',
          connecting: 'Conectando',
          restart: 'Restart',
        },
        toolTips: {
          disconnected: {
            title: 'Falha ao iniciar sessão do WhatsApp',
            content: 'Certifique-se de que seu celular esteja conectado à internet e tente novamente, ou solicite um novo QR Code',
          },
          qrcode: {
            title: 'Esperando leitura do QR Code',
            content: "Clique no botão 'QR CODE' e leia o QR Code com o seu celular para iniciar a sessão",
          },
          connected: {
            title: 'Conexão estabelecida!',
          },
          timeout: {
            title: 'A conexão com o celular foi perdida',
            content: "Certifique-se de que seu celular esteja conectado à internet e o WhatsApp esteja aberto, ou clique no botão 'Desconectar' para obter um novo QR Code",
          },
        },
        table: {
          name: 'Nome',
          number: 'Número',
          status: 'Status',
          lastUpdate: 'Última atualização',
          default: 'Padrão',
          actions: 'Ações',
          session: 'Sessão',
        },
      },
      groupParticipants: {
        title: 'Gerenciar Grupos',
        subtitle: 'Gerencie os participantes dos grupos vinculados às suas conexões.',
        form: {
          whatsapp: 'Conexão do WhatsApp',
          group: 'Grupo',
          groupPlaceholder: 'Selecione um grupo',
          loadingGroups: 'Carregando grupos...',
          noGroups: 'Nenhum grupo disponível para esta conexão.',
          load: 'Carregar participantes',
        },
        placeholder: 'Selecione uma conexão e um grupo para carregar os participantes.',
        emptyState: 'Nenhum participante encontrado neste grupo.',
        groupIdLabel: 'ID do grupo: {{groupId}}',
        groupSizeLabel: 'Integrantes: {{size}}',
        table: {
          participant: 'Participante',
          number: 'Número',
          admin: 'Tipo',
          actions: 'Ações',
          unknown: 'Nome não identificado',
          superAdmin: 'Super administrador',
          adminLabel: 'Administrador',
          member: 'Membro',
        },
        addParticipants: {
          title: 'Adicionar participantes',
          helper: 'Informe um número completo (DDD + número) ou JID por linha, ou selecione contatos existentes abaixo. Também é possível separar por vírgula ou ponto e vírgula.',
          placeholder: '5511999999999\n5511888888888@s.whatsapp.net',
          button: 'Adicionar ao grupo',
          contactsLabel: 'Selecionar contatos existentes',
          contactsPlaceholder: 'Digite para buscar contatos',
          contactsNoOptions: 'Nenhum contato encontrado para esta busca.',
          contactsLoading: 'Carregando contatos...',
        },
        createGroup: {
          title: 'Criar novo grupo',
          subtitle: 'Defina o assunto e escolha os participantes iniciais para criar um grupo na conexão selecionada.',
          openButton: 'Criar grupo',
          subjectLabel: 'Assunto do grupo',
          subjectPlaceholder: 'Ex.: Equipe Suporte',
          contactsLabel: 'Adicionar contatos existentes',
          contactsPlaceholder: 'Digite para buscar contatos',
          contactsNoOptions: 'Nenhum contato encontrado para esta busca.',
          contactsLoading: 'Carregando contatos...',
          numbersPlaceholder: '5511999999999\n5511888888888@s.whatsapp.net',
          button: 'Criar grupo',
          cancel: 'Cancelar',
          toasts: {
            missingWhatsapp: 'Selecione a conexão para criar o grupo.',
            subjectRequired: 'Informe um assunto para criar o grupo.',
            noNumbers: 'Adicione ao menos um número ou contato para continuar.',
            success: 'Grupo criado com sucesso.',
          },
        },
        actions: {
          remove: 'Remover participante',
          refresh: 'Atualizar lista',
        },
        confirmation: {
          removeParticipant: 'Deseja remover {{number}} do grupo?',
        },
        toasts: {
          missingInformation: 'Selecione a conexão e o grupo.',
          loadSuccess: 'Participantes atualizados com sucesso.',
          noNumbers: 'Informe pelo menos um número ou contato para prosseguir.',
          addSuccess: 'Participantes adicionados com sucesso.',
          removeSuccess: 'Participante removido com sucesso.',
        },
      },
      whatsappModal: {
        title: {
          add: 'Adicionar WhatsApp',
          edit: 'Editar WhatsApp',
        },
        tabs: {
          general: 'Geral',
          messages: 'Mensagens',
          assessments: 'Avaliações',
          integrations: 'Integrações',
          schedules: 'Horário de expediente',
        },
        form: {
          name: 'Nome',
          default: 'Padrão',
          sendIdQueue: 'Fila',
          timeSendQueue: 'Redirecionar para fila em X minutos',
          queueRedirection: 'Redirecionamento de Fila',
          outOfHoursMessage: 'Mensagem de fora de expediente',
          queueRedirectionDesc: 'Selecione uma fila para os contatos que não possuem fila serem redirecionados',
          agent: 'Agente',
          prompt: 'Prompt',
          noAgent: 'Nenhum agente',
          agentTestModeHint: 'Este agente está em modo de teste. Somente os telefones da whitelist usarão o agente; os demais seguirão o fluxo normal do chatbot por filas.',
          agentLiveModeHint: 'Este agente está liberado para toda a conexão. Enquanto estiver vinculado aqui, ele responderá antes do fluxo normal do chatbot.',
          //maxUseBotQueues: "Enviar bot x vezes",
          //timeUseBotQueues: "Intervalo em minutos entre envio de bot",
          expiresTicket: 'Encerrar chats abertos após x minutos',
          expiresInactiveMessage: 'Mensagem de encerramento por inatividade',
          greetingMessage: 'Mensagem de saudação',
          complationMessage: 'Mensagem de conclusão',
        },
        buttons: {
          okAdd: 'Adicionar',
          okEdit: 'Salvar',
          cancel: 'Cancelar',
          generateApiToken: 'Gerar Token API',
        },
        success: 'WhatsApp salvo com sucesso.',
        toasts: {
          tokenCopied: 'Token copiado para a área de transferência!',
          variableCopied: 'Variável copiada para a área de transferência!',
        },
      },
      qrCode: {
        message: 'Leia o QrCode para iniciar a sessão',
      },
      contacts: {
        title: 'Contatos',
        toasts: {
          deleted: 'Contato excluído com sucesso!',
          deletedAll: 'Todos contatos excluídos com sucesso!',
        },
        searchPlaceholder: 'Pesquisar...',
        confirmationModal: {
          deleteTitle: 'Deletar ',
          deleteAllTitle: 'Deletar Todos',
          importTitle: 'Importar contatos',
          deleteMessage: 'Tem certeza que deseja deletar este contato? Todos os tickets relacionados serão perdidos.',
          deleteAllMessage: 'Tem certeza que deseja deletar todos os contatos? Todos os tickets relacionados serão perdidos.',
          importMessage: 'Deseja importar todos os contatos do telefone?',
        },
        // TODO non used
        // confirmationModal: {
        //   importTitlte: 'Importar contatos',
        //   importMessage:
        //    'Esta ação irá importar os contatos salvos na agenda do WhatsApp. Alguns modelos podem não
        //  permitir essa funcionalidade ou de acordo com sua configuração de privacidade! Verifique em até 1 hora o resultado.',
        //   deleteTitle: 'Deletar',
        //   deleteMessage: 'Tem certeza que deseja deletar este contato? Todos os atendimentos relacionados serão perdidos.',
        // },
        buttons: {
          import: 'Importar Contatos',
          importSheet: 'Import. Excel',
          add: 'Adicionar Contato',
          export: 'Exportar Contatos',
          delete: 'Excluir Todos Contatos',
        },
        table: {
          name: 'Nome',
          whatsapp: 'WhatsApp',
          email: 'Email',
          actions: 'Ações',
        },
      },
      queueIntegrationModal: {
        title: {
          add: 'Adicionar projeto',
          edit: 'Editar projeto',
        },
        form: {
          id: 'ID',
          type: 'Tipo',
          name: 'Nome',
          projectName: 'Nome do Projeto',
          language: 'Linguagem',
          jsonContent: 'JsonContent',
          urlN8N: 'URL',
          typebotSlug: 'Typebot - Slug',
          typebotExpires: 'Tempo em minutos para expirar uma conversa',
          typebotKeywordFinish: 'Palavra para finalizar o ticket',
          typebotKeywordRestart: 'Palavra para reiniciar o fluxo',
          typebotRestartMessage: 'Mensagem ao reiniciar a conversa',
          typebotUnknownMessage: 'Mensagem de opção inválida',
          typebotDelayMessage: 'Intervalo (ms) entre mensagens',
        },
        buttons: {
          okAdd: 'Adicionar',
          okEdit: 'Salvar',
          cancel: 'Cancelar',
          test: 'Testar Bot',
        },
        messages: {
          testSuccess: 'Integração testada com sucesso!',
          addSuccess: 'Integração adicionada com sucesso.',
          editSuccess: 'Integração editada com sucesso.',
        },
      },
      sideMenu: {
        name: 'Menu Lateral Inicial',
        note: 'Se habilitado, o menu lateral irá iniciar fechado',
        options: {
          enabled: 'Aberto',
          disabled: 'Fechado',
        },
      },
      promptModal: {
        form: {
          name: 'Nome',
          prompt: 'Prompt',
          testNumbers: 'Telefones liberados para teste',
          testNumbersPlaceholder: 'Ex.: 5511999999999, 5511888888888',
          testNumbersHelp: 'Separe os telefones por vírgula. Se preenchido, só esses números entrarão no fluxo real do prompt.',
          fallbackQueue: 'Fila padrão quando o agente não souber responder',
          transferQueues: 'Filas que o agente pode transferir por assunto',
          voice: 'Voz',
          max_tokens: 'Máximo de Tokens na resposta',
          temperature: 'Temperatura',
          apikey: 'API Key',
          max_messages: 'Máximo de mensagens no Histórico',
          voiceKey: 'Chave da API de Voz',
          voiceRegion: 'Região de Voz',
        },
        success: 'Prompt salvo com sucesso!',
        title: {
          add: 'Adicionar Agente',
          edit: 'Editar Agente',
        },
        buttons: {
          okAdd: 'Adicionar',
          okEdit: 'Salvar',
          cancel: 'Cancelar',
        },
      },
      prompts: {
        title: 'Agente',
        table: {
          name: 'Nome',
          queue: 'Setor/Fila',
          max_tokens: 'Máximo Tokens Resposta',
          actions: 'Ações',
        },
        confirmationModal: {
          deleteTitle: 'Excluir',
          deleteMessage: 'Você tem certeza? Essa ação não pode ser revertida!',
        },
        buttons: {
          add: 'Adicionar Agente',
          test: 'Testar agente',
          edit: 'Editar agente',
          delete: 'Excluir agente',
        },
        testChat: {
          title: 'Teste do agente',
          modalTitle: 'Simulador do agente',
          topline: 'Ambiente de validação',
          queueLabel: 'Fila de transferência',
          emptyTitle: 'Escolha um prompt para testar',
          emptyDescription: 'Use o botão de teste na tabela para abrir uma conversa simulada com o agente.',
          startTitle: 'Conversa pronta para teste',
          startDescription: 'Envie uma mensagem e o backend responderá usando o prompt e as configurações salvas.',
          emptyConversation: 'Ainda não há mensagens nesta simulação. Envie a primeira pergunta para validar o comportamento do agente.',
          inputLabel: 'Sua mensagem',
          inputPlaceholder: 'Ex.: Quero cancelar meu pedido e falar com um atendente.',
          send: 'Enviar',
          close: 'Fechar',
          clear: 'Limpar conversa',
          historyHint: 'O teste respeita o limite de até {{count}} mensagens no histórico do agente.',
          footerHint: 'As respostas aqui não criam ticket nem transferem conversa real.',
          you: 'Você',
          agent: 'Agente',
          transferBadge: 'Transferência sugerida',
        },
      },
      contactModal: {
        title: {
          add: 'Adicionar contato',
          edit: 'Editar contato',
        },
        form: {
          mainInfo: 'Dados do contato',
          extraInfo: 'Informações adicionais',
          name: 'Nome',
          number: 'Número do Whatsapp',
          birthday: 'Aniversário',
          email: 'Email',
          extraName: 'Nome do campo',
          extraValue: 'Valor',
          disableBot: 'Desabilitar chatbot',
          whatsapp: 'Conexão Origem:',
          leadSource: {
            label: 'Origem do lead',
            unset: 'Definir origem do lead',
            instagram: 'Instagram',
            facebook: 'Facebook',
            google_ads: 'Google Ads',
            youtube: 'YouTube',
            ai: 'IA (ChatGPT/outras)',
            whatsapp: 'WhatsApp direto',
            referral: 'Indicação',
            site: 'Site',
            other: 'Outro',
          },
        },
        buttons: {
          addExtraInfo: 'Adicionar informação',
          okAdd: 'Adicionar',
          okEdit: 'Salvar',
          cancel: 'Cancelar',
        },
        success: 'Contato salvo com sucesso.',
      },
      queueModal: {
        title: {
          add: 'Adicionar fila',
          edit: 'Editar fila',
        },
        toasts: {
          deleted: 'Registro excluído',
        },
        confirmationModal: {
          deleteTitle: 'Excluir',
          deleteMessage: 'Esta ação não pode ser revertida.',
        },
        form: {
          name: 'Nome',
          color: 'Cor',
          greetingMessage: 'Mensagem de saudação',
          complationMessage: 'Mensagem de conclusão',
          outOfHoursMessage: 'Mensagem de fora de expediente',
          ratingMessage: 'Mensagem de avaliação',
          token: 'Token',
          orderQueue: 'Ordem da fila (Bot)',
          autoCloseTicket: 'Finalizar ticket automaticamente ao selecionar',
          sendCompletionMessage: 'Enviar mensagem de finalização',
          autoCloseTicketHelp: 'Encerra o ticket após a mensagem desta fila ou opção, sem seguir para subopções ou transferências. A mensagem de finalização é a configurada na conexão.',
          integrationId: 'Integração',
          tagsToAdd: 'Tags para adicionar',
          tagsToRemove: 'Tags para remover',
        },
        buttons: {
          okAdd: 'Adicionar',
          okEdit: 'Salvar',
          cancel: 'Cancelar',
          attach: 'Anexar Arquivo',
        },
        serviceHours: {
          dayWeek: 'Dia da semana',
          startTimeA: 'Hora Inicial - 1',
          endTimeA: 'Hora Final - 1',
          startTimeB: 'Hora Inicial - 2',
          endTimeB: 'Hora Final - 2',
          monday: 'Segunda-feira',
          tuesday: 'Terça-feira',
          wednesday: 'Quarta-feira',
          thursday: 'Quinta-feira',
          friday: 'Sexta-feira',
          saturday: 'Sábado',
          sunday: 'Domingo',
        },
      },
      qrCodeModal: {
        title: 'QrCode',
        connectTitle: 'Conectar ao WhatsApp Web',
        waiting: 'Aguardando geração do QR Code...',
        loadingQr: 'Buscando QR Code...',
        emptyTitle: 'QR Code ainda não gerado',
        emptyHelper: 'Inicie uma nova geração para conectar com a câmera do WhatsApp.',
        generateQrButton: 'Gerar QR Code',
        refreshesIn: 'Atualiza em:',
        expiresSoon: 'O QR Code expira em breve.',
        tabs: {
          qrCode: 'QR Code',
          pairingCode: 'Código',
        },
        qrInstructions: {
          openWhatsApp: 'Abra o WhatsApp no celular',
          openSettings: 'Vá em Menu ou Configurações',
          linkedDevices: 'Selecione Dispositivos conectados',
          scanQrCode: 'Aponte a câmera para o QR Code',
        },
        pairing: {
          countryCodeLabel: 'DDI',
          phoneLabel: 'Número do WhatsApp',
          phonePlaceholder: '11999999999',
          phoneHelper: 'Informe DDD e número. Use somente dígitos.',
          invalidPhone: 'Informe um número válido com código do país e somente dígitos.',
          generateButton: 'Gerar código',
          codeHelper: 'No celular, escolha Conectar com número de telefone e digite este código.',
          instructions: {
            openWhatsApp: 'Abra o WhatsApp no celular',
            linkDevice: 'Vá em Dispositivos conectados e toque em Conectar um dispositivo',
            enterCode: 'Escolha conectar com número de telefone e informe o código gerado',
          },
        },
      },
      userModal: {
        title: {
          add: 'Adicionar usuário',
          edit: 'Editar usuário',
        },
        form: {
          name: 'Nome',
          email: 'Email',
          password: 'Senha',
          cpf: 'CPF',
          profile: 'Perfil',
          whatsapp: 'Conexão Padrão',
          whatsapps: 'Conexões permitidas',
          whatsappsHelper: 'Deixe vazio para liberar todas as conexões',
          SuperIs: 'DEFINIR SUPERUSER (Somente Admin)',
          allTicket: 'Ticket Sem Fila [Invisível]',
          allTicketEnabled: 'Habilitado',
          allTicketDesabled: 'Desabilitado',
          viewAllTickets: 'Ver Todos os Tickets da Fila',
          viewAllTicketsEnabled: 'Habilitado',
          viewAllTicketsDesabled: 'Desabilitado',
        },
        buttons: {
          okAdd: 'Adicionar',
          okEdit: 'Salvar',
          cancel: 'Cancelar',
        },
        success: 'Usuário salvo com sucesso.',
      },
      scheduleModal: {
        title: {
          add: 'Novo Agendamento',
          edit: 'Editar Agendamento',
        },
        form: {
          body: 'Mensagem',
          contact: 'Contato',
          sendAt: 'Data de Agendamento',
          sentAt: 'Data de Envio',
          geral: 'Abrir Ticket?',
        },
        buttons: {
          okAdd: 'Adicionar',
          okEdit: 'Salvar',
          cancel: 'Cancelar',
        },
        success: 'Agendamento salvo com sucesso.',
        validation: {
          pastDate: 'A data deve ser futura.',
          invalidDate: 'Data ou hora de agendamento inválida.',
        },
        daySelectionInfo: 'Selecione os dias da semana em que a mensagem será enviada.',
        recurringEditInfo: 'Esse agendamento é recorrente. As alterações afetam apenas os próximos envios.',
        recurringEditSingleInfo: 'Este agendamento faz parte de uma recorrência. As alterações serão aplicadas somente a ele. Para alterar todos, edite o agendamento principal.',
      },
      tagModal: {
        title: {
          add: 'Nova Tag',
          edit: 'Editar Tag',
        },
        form: {
          name: 'Nome',
          color: 'Cor',
        },
        buttons: {
          okAdd: 'Adicionar',
          okEdit: 'Salvar',
          cancel: 'Cancelar',
        },
        success: 'Tag salvo com sucesso.',
      },
      chat: {
        noTicketMessage: 'Selecione um ticket para começar a conversar.',
      },
      uploads: {
        titles: {
          titleUploadMsgDragDrop: 'ARRASTE E SOLTE ARQUIVOS NO CAMPO ABAIXO',
          titleFileList: 'Lista de arquivo(s)',
        },
      },
      ticketsManager: {
        buttons: {
          newTicket: 'Novo',
          closeallTicket: 'Fechar',
        },
      },
      ticketsQueueSelect: {
        placeholder: 'Filas',
      },
      ticketsWhatsappSelect: {
        placeholder: 'Conexões',
      },
      tickets: {
        inbox: {
          closedAllTickets: 'Fechar todos os tickets?',
          closedAll: 'Fechar Todos',
          newTicket: 'Novo Ticket',
          yes: 'SIM',
          no: 'NÃO',
          open: 'Abertos',
          resolverd: 'Resolvidos',
        },
        toasts: {
          deleted: 'O atendimento que você estava foi deletado.',
        },
        notification: {
          message: 'Mensagem de',
        },
        tabs: {
          open: { title: 'Abertas' },
          closed: { title: 'Resolvidos' },
          search: { title: 'Busca' },
        },
        search: {
          placeholder: 'Buscar atendimento e mensagens',
          filterConnections: 'Filtro por conexões',
          filterContacts: 'Filtro por contato',
          filterConections: 'Filtro por Conexão',
          filterConectionsOptions: {
            open: 'Aberto',
            closed: 'Fechado',
            pending: 'Pendente',
          },
          filterUsers: 'Filtro por Usuarios',
          ticketsPerPage: 'Tickets por página',
        },
        buttons: {
          showAll: 'Todos',
        },
      },
      transferTicketModal: {
        title: 'Transferir Ticket',
        fieldLabel: 'Digite para buscar usuários',
        fieldQueueLabel: 'Transferir para fila',
        fieldQueuePlaceholder: 'Selecione uma fila',
        noOptions: 'Nenhum usuário encontrado com esse nome',
        buttons: {
          ok: 'Transferir',
          cancel: 'Cancelar',
        },
      },
      ticketsList: {
        called: 'Chamado',
        pendingHeader: 'Aguardando',
        assignedHeader: 'Atendendo',
        awaitingResponseToggle: 'Sem resposta',
        filters: {
          title: 'Filtros',
          tags: 'Tags',
          searchTags: 'Buscar tags',
          tagsHint: 'Exibe tickets com todas as tags selecionadas. As alterações são aplicadas automaticamente.',
          activeTags: '{{count}} tag selecionada',
          activeTags_plural: '{{count}} tags selecionadas',
          clearTags: 'Limpar tags',
          loadingTags: 'Carregando tags...',
          noTags: 'Nenhuma tag encontrada',
          open: 'Mostrar tags',
          close: 'Fechar opções',
        },
        noTicketsTitle: 'Nada aqui!',
        noTicketsMessage: 'Nenhum atendimento encontrado com esse status ou termo pesquisado',
        noAwaitingResponseTitle: 'Sem tickets aguardando retorno',
        noAwaitingResponseMessage: 'Nenhum ticket aberto está com a última mensagem do contato aguardando resposta da equipe.',
        sort: {
          newestFirst: 'Mais recentes primeiro. Clique para mostrar as mais antigas.',
          oldestFirst: 'Mais antigas primeiro. Clique para mostrar as mais recentes.',
        },
        buttons: {
          accept: 'Aceitar',
          closed: 'Finalizar',
          transfer: 'Transferir',
          reopen: 'Reabrir',
          exportAsPDF: 'Exportar em PDF',
        },
        pendingEvaluationTag: 'Aguardando avaliação',
        pendingEvaluationModal: {
          title: 'Ticket aguardando avaliação',
          message: 'Caso finalize o ticket agora, a avaliação poderá não ser contabilizada e isso pode ir contra os direcionamentos da empresa. Deseja finalizar mesmo assim?',
        },
      },
      newTicketModal: {
        title: 'Criar Ticket',
        fieldLabel: 'Digite para pesquisar o contato',
        add: 'Adicionar',
        buttons: {
          ok: 'Salvar',
          cancel: 'Cancelar',
        },
      },
      mainDrawer: {
        listItems: {
          dashboard: 'Dashboard',
          kanban: 'Kanban',
          connections: 'Conexões',
          groupParticipants: 'Gerenciar Grupos',
          tickets: 'Atendimentos',
          quickMessages: 'Respostas Rápidas',
          tasks: 'Tarefas',
          contacts: 'Contatos',
          queues: 'Filas & Chatbot',
          tags: 'Tags',
          administration: 'Administração',
          users: 'Usuários',
          settings: 'Configurações',
          helps: 'Ajuda',
          messagesAPI: 'API',
          schedules: 'Agendamentos',
          agenda: 'Agenda',
          campaigns: 'Campanhas',
          annoucements: 'Informativos',
          backups: 'Backups',
          loglauncher: 'Atualizações',
          chats: 'Chat Interno',
          financeiro: 'Financeiro',
          files: 'Lista de arquivos',
          prompts: 'Open.Ai',
          reports: 'Relatórios',
          queueIntegration: 'Integrações',
          listagem: 'Listagem',
          contactLists: 'Listas de Contatos',
          campaignsConfig: 'Configuracoes',
        },
        appBar: {
          notRegister: 'Nenhuma mensagem',
          user: {
            profile: 'Perfil',
            logout: 'Sair',
          },
          impersonation: {
            banner: 'Você está acessando {{company}} como administrador.',
            back: 'Voltar ao acesso master',
            enter: 'Acessar como administrador',
          },
        },
      },
      queueIntegration: {
        title: 'Integrações',
        table: {
          id: 'ID',
          type: 'Tipo',
          name: 'Nome',
          projectName: 'Nome do Projeto',
          language: 'Linguagem',
          lastUpdate: 'Ultima atualização',
          actions: 'Ações',
        },
        buttons: {
          add: 'Adicionar Projeto',
        },
        searchPlaceholder: 'Pesquisar...',
        confirmationModal: {
          deleteTitle: 'Excluir',
          deleteMessage: 'Você tem certeza? Essa ação não pode ser revertida! e será removida das filas e conexões vinculadas',
        },
        toasts: {
          deleted: 'Integração excluída com sucesso!',
        },
      },
      reports: {
        title: 'Relatórios de Atendimentos',
        table: {
          id: 'Ticket',
          user: 'Usuário',
          dateOpen: 'Data Abertura',
          dateClose: 'Data Fechamento',
          NPS: 'NPS',
          status: 'Status',
          whatsapp: 'Conexão',
          queue: 'Fila',
          actions: 'Ações',
          lastMessage: 'Últ. Mensagem',
          contact: 'Cliente',
          supportTime: 'Tempo de Atendimento',
        },
        buttons: {
          filter: 'Aplicar Filtro',
        },
        searchPlaceholder: 'Pesquisar...',
      },
      files: {
        title: 'Lista de arquivos',
        table: {
          name: 'Nome',
          contacts: 'Contatos',
          actions: 'Ação',
        },
        toasts: {
          deleted: 'Lista excluída com sucesso!',
          deletedAll: 'Todas as listas foram excluídas com sucesso!',
        },
        buttons: {
          add: 'Adicionar',
          deleteAll: 'Deletar Todos',
        },
        confirmationModal: {
          deleteTitle: 'Deletar',
          deleteAllTitle: 'Deletar Todos',
          deleteMessage: 'Tem certeza que deseja deletar esta lista?',
          deleteAllMessage: 'Tem certeza que deseja deletar todas as listas?',
        },
      },
      languages: {
        undefined: 'Idioma',
        'pt-BR': 'Português',
        es: 'Español',
        en: 'English',
        tr: 'Türkçe',
      },
      messagesAPI: {
        title: 'API',
        textMessage: {
          number: 'Número',
          body: 'Mensagem',
          token: 'Token cadastrado',
        },
        mediaMessage: {
          number: 'Número',
          body: 'Nome do arquivo',
          media: 'Arquivo',
          token: 'Token cadastrado',
        },
      },
      notifications: {
        noTickets: 'Nenhum chamado',
      },
      quickMessages: {
        title: 'Respostas Rápidas',
        searchPlaceholder: 'Pesquisar...',
        noAttachment: 'Sem anexo',
        confirmationModal: {
          deleteTitle: 'Exclusão',
          deleteMessage: 'Esta ação é irreversível! Deseja prosseguir?',
        },
        sendConfirm: {
          title: 'Enviar resposta rápida',
          message: 'Tem certeza que deseja enviar esta mensagem?',
          dontShowAgain: 'Não mostrar novamente',
          enable: 'Confirmar envio de resposta rápida',
        },
        buttons: {
          add: 'Adicionar',
          attach: 'Anexar Arquivo',
          cancel: 'Cancelar',
          edit: 'Editar',
        },
        toasts: {
          success: 'Atalho adicionado com sucesso!',
          deleted: 'Atalho removido com sucesso!',
        },
        dialog: {
          title: 'Mensagem Rápida',
          shortcode: 'Atalho',
          message: 'Resposta',
          save: 'Salvar',
          cancel: 'Cancelar',
          geral: 'Permitir editar',
          add: 'Adicionar',
          edit: 'Editar',
          visao: 'Permitir visão',
          active: 'Ativo',
          inactive: 'Inativo',
          editBeforeSend: 'Editar antes de enviar',
          // geral: 'Global',
          status: 'Global',
        },
        validation: {
          required: 'Obrigatório',
        },
        table: {
          shortcode: 'Atalho',
          message: 'Mensagem',
          actions: 'Ações',
          mediaName: 'Nome do Arquivo',
          status: 'Global',
        },
      },
      messageVariablesPicker: {
        label: 'Variavéis disponíveis',
        vars: {
          contactFirstName: 'Primeiro Nome',
          contactName: 'Nome',
          greeting: 'Saudação',
          protocolNumber: 'Protocolo',
          date: 'Data',
          hour: 'Hora',
        },
      },
      contactLists: {
        title: 'Listas de Contatos',
        table: {
          name: 'Nome',
          contacts: 'Contatos',
          actions: 'Ações',
        },
        buttons: {
          add: 'Nova Lista',
        },
        dialog: {
          name: 'Nome',
          company: 'Empresa',
          okEdit: 'Editar',
          okAdd: 'Adicionar',
          add: 'Adicionar',
          edit: 'Editar',
          cancel: 'Cancelar',
        },
        confirmationModal: {
          deleteTitle: 'Excluir',
          deleteMessage: 'Esta ação não pode ser revertida.',
        },
        toasts: {
          deleted: 'Registro excluído',
        },
      },
      contactListItems: {
        title: 'Contatos',
        searchPlaceholder: 'Pesquisa',
        buttons: {
          add: 'Novo',
          lists: 'Listas',
          import: 'Importar',
        },
        dialog: {
          name: 'Nome',
          number: 'Número',
          whatsapp: 'Whatsapp',
          email: 'E-mail',
          selectContact: 'Selecionar contato',
          selectContactPlaceholder: 'Busque por um contato cadastrado',
          noOptions: 'Nenhum contato encontrado',
          okEdit: 'Editar',
          okAdd: 'Adicionar',
          add: 'Adicionar',
          edit: 'Editar',
          cancel: 'Cancelar',
        },
        table: {
          name: 'Nome',
          number: 'Número',
          whatsapp: 'Whatsapp',
          email: 'E-mail',
          actions: 'Ações',
        },
        confirmationModal: {
          deleteTitle: 'Excluir',
          deleteMessage: 'Esta ação não pode ser revertida.',
          importMessage: 'Deseja importar os contatos desta planilha? ',
          importTitlte: 'Importar',
        },
        toasts: {
          deleted: 'Registro excluído',
        },
      },
      campaigns: {
        title: 'Campanhas',
        searchPlaceholder: 'Pesquisa',
        buttons: {
          add: 'Nova Campanha',
          contactLists: 'Listas de Contatos',
          details: 'Detalhes',
        },
        table: {
          name: 'Nome',
          whatsapp: 'Conexão',
          contactList: 'Lista de Contatos',
          status: 'Status',
          scheduledAt: 'Agendamento',
          completedAt: 'Concluída',
          confirmation: 'Confirmação',
          actions: 'Ações',
        },
        dialog: {
          new: 'Nova Campanha',
          update: 'Editar Campanha',
          readonly: 'Apenas Visualização',
          form: {
            name: 'Nome',
            message1: 'Mensagem 1',
            message2: 'Mensagem 2',
            message3: 'Mensagem 3',
            message4: 'Mensagem 4',
            message5: 'Mensagem 5',
            confirmationMessage1: 'Mensagem de Confirmação 1',
            confirmationMessage2: 'Mensagem de Confirmação 2',
            confirmationMessage3: 'Mensagem de Confirmação 3',
            confirmationMessage4: 'Mensagem de Confirmação 4',
            confirmationMessage5: 'Mensagem de Confirmação 5',
            messagePlaceholder: 'Conteúdo da mensagem',
            whatsapp: 'Conexão',
            status: 'Status',
            scheduledAt: 'Agendamento',
            confirmation: 'Confirmação',
            audienceTitle: 'Destinatários da campanha',
            audienceDescription: 'Escolha uma lista pronta ou use uma tag para montar automaticamente o público a partir dos contatos com atendimentos marcados.',
            contactList: 'Lista de contatos manual',
            contactListHelper: 'Usada quando nenhum público por tag for selecionado.',
            contactListIgnoredHelper: 'Esta lista será ignorada porque o público será montado pela tag escolhida.',
            tagList: 'Público por tag',
            tagListHelper: 'Opcional. Ao escolher uma tag, a campanha usa os contatos de atendimentos que possuem essa tag.',
            tagListSelectedHelper: 'A campanha criará uma lista automática com os contatos encontrados nessa tag.',
            fileList: 'Lista de Arquivos',
          },
          buttons: {
            add: 'Adicionar',
            edit: 'Atualizar',
            okadd: 'Ok',
            cancel: 'Cancelar Disparos',
            restart: 'Reiniciar Disparos',
            close: 'Fechar',
            attach: 'Anexar Arquivo',
            report: 'Ver Relatório',
          },
        },
        confirmationModal: {
          deleteTitle: 'Excluir',
          deleteMessage: 'Esta ação não pode ser revertida.',
        },
        toasts: {
          success: 'Operação realizada com sucesso',
          cancel: 'Campanha cancelada',
          restart: 'Campanha reiniciada',
          deleted: 'Registro excluído',
        },
      },
      announcements: {
        active: 'Ativo',
        inactive: 'Inativo',
        title: 'Informativos',
        searchPlaceholder: 'Pesquisa',
        buttons: {
          add: 'Novo Informativo',
          contactLists: 'Listas de Informativos',
        },
        table: {
          priority: 'Prioridade',
          title: 'Title',
          text: 'Texto',
          mediaName: 'Arquivo',
          status: 'Status',
          actions: 'Ações',
        },
        dialog: {
          edit: 'Edição de Informativo',
          add: 'Novo Informativo',
          update: 'Editar Informativo',
          readonly: 'Apenas Visualização',
          form: {
            priority: 'Prioridade',
            title: 'Title',
            text: 'Texto',
            mediaPath: 'Arquivo',
            status: 'Status',
          },
          buttons: {
            add: 'Adicionar',
            edit: 'Atualizar',
            okadd: 'Ok',
            cancel: 'Cancelar',
            close: 'Fechar',
            attach: 'Anexar Arquivo',
          },
        },
        confirmationModal: {
          deleteTitle: 'Excluir',
          deleteMessage: 'Esta ação não pode ser revertida.',
        },
        toasts: {
          success: 'Operação realizada com sucesso',
          deleted: 'Registro excluído',
        },
      },
      campaignsConfig: {
        title: 'Configurações de Campanhas',
      },
      queues: {
        title: 'Filas & Chatbot',
        table: {
          id: 'ID',
          name: 'Nome',
          color: 'Cor',
          greeting: 'Mensagem de saudação',
          actions: 'Ações',
          orderQueue: 'Ordenação da fila (bot)',
        },
        buttons: {
          add: 'Adicionar fila',
          flow: 'Ver fluxo do bot',
          test: 'Testar fluxo do bot',
        },
        confirmationModal: {
          deleteTitle: 'Excluir',
          deleteMessage: 'Você tem certeza? Essa ação não pode ser revertida! Os atendimentos dessa fila continuarão existindo, mas não terão mais nenhuma fila atribuída.',
        },
        flow: {
          title: 'Fluxo do Bot',
          autoArrange: 'Organizar fluxo',
          exportImage: 'Gerar imagem',
        },
        test: {
          title: 'Teste do fluxo do bot',
          placeholder: 'Digite uma mensagem',
          send: 'Enviar',
          close: 'Fechar',
        },
      },
      queueSelect: {
        inputLabel: 'Filas',
        moveQueue: 'Mover para fila',
        timeToMove: 'Tempo para mover',
        timeToClose: 'Tempo para inatividade',
      },
      users: {
        title: 'Usuários',
        table: {
          id: 'ID',
          name: 'Nome',
          status: 'Conectado',
          email: 'Email',
          profile: 'Perfil',
          actions: 'Ações',
        },
        status: {
          online: 'Usuários online',
          offline: 'Usuários offline',
        },
        buttons: {
          add: 'Adicionar usuário',
        },
        toasts: {
          deleted: 'Usuário excluído com sucesso.',
        },
        confirmationModal: {
          deleteTitle: 'Excluir',
          deleteMessage: 'Todos os dados do usuário serão perdidos. Os atendimento abertos deste usuário serão movidos para a fila.',
        },
      },
      helps: {
        title: 'Central de Ajuda',
        searchPlaceholder: 'Buscar por título ou descrição',
        all: 'Todos',
      },
      schedules: {
        title: 'Agendamentos',
        confirmationModal: {
          deleteTitle: 'Você tem certeza que quer excluir este Agendamento?',
          deleteMessage: 'Esta ação não pode ser revertida.',
          deleteRecurringMessage: 'Ao excluir, todos os agendamentos vinculados a este também serão excluídos.',
        },
        table: {
          contact: 'Contato',
          body: 'Mensagem',
          sendAt: 'Data de Agendamento',
          sentAt: 'Data de Envio',
          status: 'Status',
          actions: 'Ações',
        },
        buttons: {
          add: 'Novo Agendamento',
        },
        viewModal: {
          title: 'Detalhes do Agendamento',
          attachment: 'Anexo',
          buttons: {
            edit: 'Editar',
            close: 'Fechar',
          },
          media: {
            view: 'Visualizar',
            download: 'Baixar',
          },
        },
        toasts: {
          deleted: 'Agendamento excluído com sucesso.',
          cannotEditPast: 'Não é possível editar agendamentos passados.',
          editRecurringInfo: 'Esse agendamento é recorrente. As alterações afetam apenas os próximos envios.',
          editRecurringSingleInfo: 'As alterações serão aplicadas apenas a este agendamento. Para alterar todos, edite o agendamento principal.',
        },
      },
      tags: {
        title: 'Tags',
        confirmationModal: {
          deleteTitle: 'Você tem certeza que quer excluir esta Tag?',
          deleteMessage: 'Esta ação não pode ser revertida.',
          deleteAllMessage: 'Tem certeza que deseja deletar todas as Tags?',
          deleteAllTitle: 'Deletar Todos',
        },
        table: {
          name: 'Nome',
          color: 'Cor',
          tickets: 'Contatos Tagueados',
          kanban: 'Kanban',
          yes: 'Sim',
          no: 'Não',
          actions: 'Ações',
        },
        buttons: {
          add: 'Nova Tag',
          deleteAll: 'Deletar Todas',
        },
        toasts: {
          deletedAll: 'Todas Tags excluídas com sucesso!',
          deleted: 'Tag excluído com sucesso.',
        },
      },
      customKanban: {
        title: 'Kanban Personalizado',
        subtitle: 'Monte quadros personalizados para organizar seus processos.',
        menuLabel: 'Kanban Personalizado',
        sections: {
          boards: 'Quadros',
          items: 'Itens do quadro',
          boardView: 'Quadro',
        },
        actions: {
          addBoard: 'Adicionar',
          createBoard: 'Criar quadro',
          addColumn: 'Adicionar coluna',
          addItem: 'Adicionar item',
          addContact: 'Adicionar contato',
          removeItem: 'Remover do kanban',
          goToConversation: 'Ir para conversa',
          editBoard: 'Editar quadro',
          editColumn: 'Editar coluna',
          deleteBoard: 'Excluir quadro',
          deleteColumn: 'Excluir coluna',
          edit: 'Editar',
          delete: 'Excluir',
          shareBoard: 'Compartilhar',
          moreOptions: 'Mais opções',
          saveChanges: 'Salvar alterações',
          close: 'Fechar',
        },
        form: {
          boardName: 'Nome do quadro',
          columnName: 'Nome da coluna',
          columnColor: 'Cor da coluna',
          columnSelect: 'Selecione uma coluna',
          targetType: 'Tipo de item',
          contactOption: 'Contato',
          ticketOption: 'Ticket',
          contactId: 'ID do contato',
          ticketId: 'ID do ticket',
          searchPlaceholder: 'Buscar por nome ou número do contato',
          sharedUsers: 'Compartilhar com',
          sharedUsersPlaceholder: 'Selecione os usuários para compartilhar o quadro',
          sharedUsersLoading: 'Carregando usuários...',
          sharedUsersNoOptions: 'Nenhum usuário encontrado',
        },
        labels: {
          columnsCount: 'Colunas: {{count}}',
          itemsCount: 'Itens: {{count}}',
          totalItems: 'Total de itens: {{count}}',
          contactInfo: 'Contato #{{id}}',
          ticketInfo: 'Ticket #{{id}}',
          contactWithoutName: 'Contato sem nome',
          ticketWithoutSubject: 'Ticket sem assunto',
          contactNumber: 'Número: {{number}}',
          contactWithoutNumber: 'Contato sem número',
          sharedWith: 'Compartilhado com',
          sharedWithCount: 'Compartilhado com {{count}} usuário(s)',
          you: 'Você',
        },
        emptyStates: {
          noBoards: 'Nenhum quadro cadastrado ainda.',
          selectBoard: 'Selecione ou crie um quadro para começar.',
          noColumns: 'Nenhuma coluna cadastrada neste quadro.',
          noItems: 'Nenhum item nesta coluna ainda.',
          noContacts: 'Nenhum contato encontrado com esses filtros.',
          noSharedUsers: 'Somente você tem acesso por enquanto.',
        },
        toasts: {
          loadError: 'Não foi possível carregar os quadros do kanban.',
          boardCreated: 'Quadro criado com sucesso!',
          boardUpdated: 'Quadro atualizado com sucesso!',
          boardDeleted: 'Quadro excluído com sucesso!',
          boardError: 'Não foi possível criar o quadro.',
          boardUpdateError: 'Não foi possível atualizar o quadro.',
          boardDeleteError: 'Não foi possível excluir o quadro.',
          columnCreated: 'Coluna adicionada com sucesso!',
          columnUpdated: 'Coluna atualizada com sucesso!',
          columnDeleted: 'Coluna excluída com sucesso!',
          columnMoved: 'Coluna movida com sucesso!',
          columnError: 'Não foi possível adicionar a coluna.',
          columnUpdateError: 'Não foi possível atualizar a coluna.',
          columnDeleteError: 'Não foi possível excluir a coluna.',
          columnMoveError: 'Não foi possível mover a coluna.',
          itemCreated: 'Item adicionado com sucesso!',
          itemError: 'Não foi possível adicionar o item.',
          itemMoved: 'Item movido com sucesso!',
          itemMoveError: 'Não foi possível mover o item.',
          itemDeleted: 'Item removido com sucesso!',
          itemDeleteError: 'Não foi possível remover o item.',
          contactLoadError: 'Não foi possível carregar os contatos.',
          sharedUsersLoadError: 'Não foi possível carregar os usuários para compartilhar o quadro.',
          boardPermissionError: 'Apenas o proprietário do quadro pode realizar essa ação.',
          ticketNavigationError: 'Não foi possível localizar o ticket para este item.',
        },
        validations: {
          boardName: 'Informe um nome para o quadro.',
          columnName: 'Informe um nome para a coluna.',
          selectBoard: 'Selecione um quadro antes de continuar.',
          selectColumn: 'Selecione uma coluna.',
          targetId: 'Informe o identificador do contato ou ticket.',
          targetNumber: 'Informe um identificador numérico válido.',
        },
        dialogs: {
          addBoardTitle: 'Adicionar novo quadro',
          editBoardTitle: 'Editar quadro',
          addContactTitle: 'Adicionar contato à coluna',
          addColumnTitle: 'Adicionar nova coluna',
          editColumnTitle: 'Editar coluna',
          deleteBoardTitle: 'Excluir quadro',
          deleteColumnTitle: 'Excluir coluna',
        },
        confirmations: {
          deleteBoard: 'Excluir o quadro "{{name}}"? Esta ação não poderá ser desfeita.',
          deleteColumn: 'Excluir a coluna "{{name}}" e todos os seus itens?',
        },
      },
      crm: {
        title: 'CRM Comercial',
        subtitle: 'Acompanhe oportunidades por contato e mova cada negócio pelo funil de vendas.',
        menuLabel: 'CRM Comercial',
        conversionsMenuLabel: 'Conversões CRM',
        reportsMenuLabel: 'Relatórios CRM',
        menu: {
          board: 'Funil de vendas',
          conversions: 'Conversões',
          reports: 'Relatórios',
          settings: 'Configurações',
        },
        products: {
          manage: 'Produtos/serviços',
          managerTitle: 'Produtos e serviços',
          managerDescription: 'Cadastre o que você vende para vincular às oportunidades do CRM.',
          add: 'Novo produto/serviço',
          addTitle: 'Cadastrar produto/serviço',
          editTitle: 'Editar produto/serviço',
          edit: 'Editar',
          delete: 'Excluir',
          name: 'Nome',
          type: 'Tipo',
          typeProduct: 'Produto',
          typeService: 'Serviço',
          price: 'Preço (R$)',
          description: 'Descrição',
          active: 'Ativo',
          inactive: 'Inativo',
          search: 'Buscar produto/serviço',
          noResults: 'Nenhum produto/serviço encontrado.',
          createFromSearch: 'Cadastrar "{{name}}"',
          create: 'Cadastrar produto/serviço',
          assign: 'Atribuir produto/serviço',
          remove: 'Remover produto/serviço',
          noPrice: 'Sem preço',
          label: 'Produto/serviço',
          deleteConfirmation: 'Deseja excluir "{{name}}"? Só é possível excluir itens sem oportunidades vinculadas; caso contrário, desative.',
          toasts: {
            nameRequired: 'Informe o nome do produto/serviço.',
            invalidPrice: 'Informe um preço válido.',
            created: 'Produto/serviço cadastrado com sucesso!',
            updated: 'Produto/serviço atualizado com sucesso!',
            deleted: 'Produto/serviço excluído com sucesso!',
            assigned: 'Produto/serviço atribuído à oportunidade!',
            removed: 'Produto/serviço removido da oportunidade!',
          },
        },
        transfer: {
          menuItem: 'Copiar ou mover para outro pipeline',
          title: 'Copiar ou mover oportunidade',
          description: 'Escolha para onde "{{name}}" deve ir.',
          copy: 'Copiar',
          move: 'Mover',
          copyHelper: 'Cria uma nova oportunidade no destino e mantém a original onde está (tags e produto são copiados).',
          moveHelper: 'Leva a oportunidade para o destino, mantendo histórico, tags, produto e follow up.',
          targetPipeline: 'Pipeline de destino',
          targetStage: 'Stage de destino',
          currentPipeline: '(atual)',
          targetRequired: 'Selecione o pipeline e o stage de destino.',
          copied: 'Oportunidade copiada com sucesso!',
          moved: 'Oportunidade movida com sucesso!',
        },
        reports: {
          title: 'Relatórios do CRM',
          subtitle: 'Gere listagens e análises das oportunidades e exporte para Excel ou CSV.',
          periodHint: 'Considera as oportunidades criadas no período selecionado.',
          types: {
            opportunities: {
              title: 'Listagem de oportunidades',
              description: 'Todas as oportunidades com contato, pipeline, stage, produto, valor e status.',
            },
            products: {
              title: 'Vendas por produto/serviço',
              description: 'Quantidade, valores ganhos, perdidos e conversão de cada produto/serviço.',
            },
            owners: {
              title: 'Desempenho por responsável',
              description: 'Resultados de cada responsável: oportunidades, ganhos, perdas e ticket médio.',
            },
          },
          filters: {
            startDate: 'Data inicial',
            endDate: 'Data final',
            pipeline: 'Pipeline',
            allPipelines: 'Todos os pipelines',
            stage: 'Stage',
            allStages: 'Todos os stages',
            status: 'Status',
            allStatuses: 'Todos os status',
            product: 'Produto/serviço',
            allProducts: 'Todos os produtos/serviços',
            noProduct: 'Sem produto/serviço',
            owner: 'Responsável',
            allOwners: 'Todos os responsáveis',
            noOwner: 'Sem responsável',
            apply: 'Gerar relatório',
          },
          exportXlsx: 'Exportar Excel',
          exportCsv: 'Exportar CSV',
          empty: 'Nenhum resultado para os filtros selecionados.',
          rowsCount: '{{count}} registro(s)',
          total: 'Total',
          status: {
            open: 'Em aberto',
            won: 'Ganha',
            lost: 'Perdida',
          },
          columns: {
            id: 'ID',
            title: 'Oportunidade',
            status: 'Status',
            contact: 'Contato',
            number: 'Telefone',
            email: 'E-mail',
            pipeline: 'Pipeline',
            stage: 'Stage',
            product: 'Produto/serviço',
            productType: 'Tipo',
            owner: 'Responsável',
            amount: 'Valor',
            source: 'Origem',
            lossCategory: 'Categoria da perda',
            lostReason: 'Motivo da perda',
            tags: 'Tags',
            expectedCloseDate: 'Previsão de fechamento',
            createdAt: 'Criada em',
            updatedAt: 'Atualizada em',
            totalCount: 'Oportunidades',
            totalAmount: 'Valor total',
            openCount: 'Em aberto',
            openAmount: 'Valor em aberto',
            wonCount: 'Ganhas',
            wonAmount: 'Valor ganho',
            lostCount: 'Perdidas',
            lostAmount: 'Valor perdido',
            conversionRate: 'Conversão',
            averageWonTicket: 'Ticket médio',
          },
          summary: {
            count: 'Oportunidades',
            totalAmount: 'Valor total',
            wonAmount: 'Valor ganho',
            conversionRate: 'Taxa de conversão',
          },
        },
        actions: {
          pipelineOptions: 'Opções da pipeline',
          moreOptions: 'Mais opções',
          clearSearch: 'Limpar busca',
          managePipeline: 'Gerenciar pipeline',
          manageStages: 'Gerenciar stages',
          searchOpportunities: 'Buscar por nome, título ou telefone',
          addPipeline: 'Criar pipeline',
          editPipeline: 'Editar pipeline',
          duplicatePipeline: 'Duplicar pipeline',
          deletePipeline: 'Excluir pipeline',
          deleteStage: 'Excluir stage',
          selectPipeline: 'Selecionar',
          addStage: 'Novo',
          editStage: 'Editar stage',
          moveStageUp: 'Mover stage para cima',
          moveStageDown: 'Mover stage para baixo',
          addOpportunity: 'Nova oportunidade',
          addOpportunityToStage: 'Nova oportunidade neste stage',
          openConversation: 'Ir para conversa',
          previewConversation: 'Espiar conversa',
          deleteOpportunity: 'Excluir oportunidade',
          moveOpportunity: 'Mover oportunidade',
          moveToStage: 'Mover para {{name}}',
          markWon: 'Marcar como ganho',
          markLost: 'Marcar como perdido',
          showLostStage: 'Ver perdidos',
          hideLostStage: 'Ocultar perdidos',
          manageLossCategories: 'Gerenciar motivos de perda',
          addLossCategory: 'Novo',
          editLossCategory: 'Editar motivo de perda',
          deleteLossCategory: 'Excluir motivo de perda',
          activateLossCategory: 'Ativar',
          deactivateLossCategory: 'Desativar',
          cancel: 'Cancelar',
          confirm: 'Confirmar',
          create: 'Criar',
          complete: 'Concluir',
          close: 'Fechar',
          delete: 'Excluir',
          save: 'Salvar',
          viewConversions: 'Ver conversões',
          openSettings: 'Configurações do CRM',
          backToCrm: 'Voltar ao CRM',
          refreshConversions: 'Atualizar relatório',
          completeFollowUp: 'Concluir follow up',
          manageTags: 'Gerenciar tags',
          addTag: 'Adicionar tag',
          createTag: 'Criar nova',
          editTag: 'Editar tag',
          deleteTag: 'Excluir tag',
          edit: 'Editar',
        },
        form: {
          pipeline: 'Pipeline',
          pipelineName: 'Nome do pipeline',
          stage: 'Stage',
          stageName: 'Nome do stage',
          stageColor: 'Cor do stage',
          autoMarkAsWon: 'Marcar como ganho automaticamente ao mover para este stage',
          title: 'Título da oportunidade',
          contact: 'Contato',
          opportunity: 'Oportunidade existente',
          amount: 'Valor estimado',
          expectedCloseDate: 'Previsão de fechamento',
          notes: 'Observações',
          followUpFilter: 'Filtro de follow up',
          tagFilter: 'Filtrar por tags',
          tagFilterEmpty: 'Nenhuma tag encontrada',
          followUpResponsible: 'Responsável do follow up',
          followUpDueAt: 'Próximo follow up',
          followUpNote: 'Observação do follow up',
          lostReason: 'Motivo da perda',
          lossCategory: 'Categoria da perda',
          lossCategoryName: 'Nome da categoria',
          lossCategoryActive: 'Categoria ativa',
          tagName: 'Texto da tag',
          tagColor: 'Cor da tag',
          searchTag: 'Buscar ou criar tag',
        },
        labels: {
          opportunityCount: '{{count}} oportunidade(s)',
          stageCount: '{{count}} stage(s)',
          pipelineCopyName: 'Cópia de {{name}}',
          duplicatePipelineHelper: 'Serão copiadas somente as lanes e suas configurações, sem leads ou histórico.',
          noContact: 'Contato não identificado',
          noNumber: 'Sem número',
          unassigned: 'Sem responsável',
          source: 'Origem',
          sourceTicket: 'Ticket manual',
          sourceTicketAuto: 'Ticket automático',
          sourceManual: 'Manual',
          noAmount: 'Sem valor',
          stageTime: 'Neste estágio desde {{date}}',
          stageTimeNow: 'agora',
          expectedCloseDate: 'Fechamento',
          followUp: 'Follow up',
          followUpResponsible: 'Responsável do follow up',
          followUpDueAt: 'Próximo follow up',
          followUpHistory: 'Histórico de follow up',
          followUpOutcomeAt: 'Encerrado em',
          conversationActions: 'Conversa',
          timeline: 'Timeline da negociação',
          actor: 'Responsável',
          system: 'Sistema',
          ticketReference: 'Ticket #{{id}}',
          autoWonStage: 'Stage final',
          wonStatus: 'Ganho',
          lostStatus: 'Perdido',
          lostStage: 'Perdidos',
          lostReason: 'Motivo da perda',
          lossCategory: 'Categoria da perda',
          lossCategoryActive: 'Ativa',
          lossCategoryInactive: 'Inativa',
          sortStageTimeLongestFirst: 'Ordenar por tempo no estágio: maior tempo primeiro',
          sortStageTimeShortestFirst: 'Ordenar por tempo no estágio: menor tempo primeiro',
          crmTags: 'Tags comerciais',
        },
        emptyStates: {
          noPipelines: 'Crie um pipeline para começar o CRM.',
          noOpportunities: 'Nenhuma oportunidade neste stage.',
          noStages: 'Nenhum stage cadastrado neste pipeline.',
          noTimeline: 'Nenhum evento registrado nesta oportunidade.',
          noFollowUp: 'Nenhum follow up agendado.',
          noFollowUpHistory: 'Nenhum follow up anterior registrado.',
          noFollowUpNote: 'Sem observação de follow up.',
          noLossCategories: 'Nenhuma categoria de perda cadastrada.',
          noTags: 'Nenhuma tag encontrada.',
        },
        dialogs: {
          addPipeline: 'Criar pipeline',
          editPipeline: 'Editar pipeline',
          duplicatePipeline: 'Duplicar pipeline',
          managePipeline: 'Gerenciar pipelines',
          deletePipeline: 'Excluir pipeline',
          manageStages: 'Gerenciar stages',
          addStage: 'Criar stage',
          editStage: 'Editar stage',
          deleteStage: 'Excluir stage',
          addOpportunity: 'Criar oportunidade',
          opportunityDetails: 'Detalhes da oportunidade',
          deleteOpportunity: 'Excluir oportunidade',
          deleteOpportunityConfirmation: 'Deseja excluir esta oportunidade? Esta ação não pode ser revertida.',
          markWon: 'Marcar oportunidade como ganha',
          markLost: 'Marcar oportunidade como perdida',
          manageLossCategories: 'Gerenciar motivos de perda',
          addLossCategory: 'Criar motivo de perda',
          editLossCategory: 'Editar motivo de perda',
          manageTags: 'Gerenciar tags',
          addTag: 'Criar tag',
          editTag: 'Editar tag',
        },
        ticketDialog: {
          title: 'Adicionar contato ao CRM',
          description: 'Defina onde {{name}} deve entrar no funil comercial.',
          createMode: 'Criar nova oportunidade',
          reuseMode: 'Usar oportunidade existente',
          alreadyInCrmTitle: 'Contato já está no CRM',
          alreadyInCrmDescription: 'Este contato já possui {{count}} oportunidade(s) aberta(s). Posição atual: {{pipeline}} > {{stage}}.',
          notInCrmTitle: 'Contato ainda não está no CRM',
          notInCrmDescription: 'Você pode criar uma nova oportunidade para começar o acompanhamento comercial.',
          currentPipeline: 'Pipeline atual',
          destinationStage: 'Mover para etapa',
          reuseHelper: 'Selecione a oportunidade existente e escolha apenas a nova etapa dentro da pipeline atual.',
        },
        confirmations: {
          winOpportunity: 'Deseja marcar "{{name}}" como oportunidade ganha?',
          deletePipeline: 'Deseja excluir o pipeline "{{name}}"? Esta ação remove os stages e oportunidades vinculados.',
          deleteStage: 'Deseja excluir o stage "{{name}}"? Esta ação só é permitida quando ele não possui oportunidades vinculadas.',
          deleteOpportunity: 'Deseja excluir a oportunidade "{{name}}"?',
        },
        toasts: {
          pipelineRequired: 'Selecione um pipeline antes de continuar.',
          pipelineNameRequired: 'Informe o nome do pipeline.',
          stageNameRequired: 'Informe o nome do stage.',
          opportunityFormRequired: 'Selecione o contato e o stage da oportunidade.',
          pipelineStageRequired: 'Selecione o pipeline e o stage.',
          opportunityRequired: 'Selecione a oportunidade que será reutilizada.',
          pipelineCreated: 'Pipeline criado com sucesso!',
          pipelineDuplicated: 'Pipeline duplicado com sucesso!',
          pipelineUpdated: 'Pipeline atualizado com sucesso!',
          pipelineDeleted: 'Pipeline excluído com sucesso!',
          stageCreated: 'Stage criado com sucesso!',
          stageUpdated: 'Stage atualizado com sucesso!',
          stageDeleted: 'Stage excluído com sucesso!',
          stageOrderUpdated: 'Ordem dos stages atualizada com sucesso!',
          lossCategoryRequired: 'Selecione uma categoria de perda.',
          lossCategoryNameRequired: 'Informe o nome da categoria de perda.',
          lossCategoryCreated: 'Categoria de perda criada com sucesso!',
          lossCategoryUpdated: 'Categoria de perda atualizada com sucesso!',
          lossCategoryDeleted: 'Categoria de perda excluída com sucesso!',
          automationSettingsSaved: 'Configuração de automação salva com sucesso!',
          opportunityCreated: 'Oportunidade criada com sucesso!',
          opportunityUpdated: 'Oportunidade atualizada com sucesso!',
          opportunityMoved: 'Oportunidade movida com sucesso!',
          opportunityWon: 'Oportunidade marcada como ganha!',
          opportunityLost: 'Oportunidade marcada como perdida!',
          opportunityDeleted: 'Oportunidade excluída com sucesso!',
          ticketAdded: 'Contato enviado ao CRM com sucesso!',
          ticketConversationNotFound: 'Não foi possível localizar a conversa deste ticket no CRM.',
          automationTriggerRequired: 'Informe ao menos uma fila ou palavra-chave para ativar a automação.',
          automationDaysInvalid: 'Informe um número de dias entre 1 e 365.',
          automationLossCategoryRequired: 'Selecione o motivo de perda por inatividade.',
          followUpRequired: 'Informe responsável e data/hora para salvar o follow up.',
          followUpRequiredFields: 'Informe responsável e data/hora para salvar o follow up.',
          followUpSaved: 'Follow up salvo com sucesso!',
          followUpCompleted: 'Follow up concluído com sucesso!',
          tagNameRequired: 'Informe o texto da tag.',
          tagCreated: 'Tag criada com sucesso!',
          tagUpdated: 'Tag atualizada com sucesso!',
          tagDeleted: 'Tag excluída com sucesso!',
        },
        followUp: {
          filters: {
            all: 'Todos',
            pending: 'Pendentes',
            today: 'Hoje',
            overdue: 'Atrasados',
            assigned_to_me: 'Atribuídos a mim',
          },
          status: {
            pending: 'Pendente',
            today: 'Hoje',
            overdue: 'Atrasado',
          },
        },
        settings: {
          title: 'Configurações do CRM',
          subtitle: 'Centralize os motivos de perda e configure a entrada automática de leads por pipeline.',
          automationTitle: 'Automação por pipeline',
          automationDescription: 'Crie automaticamente um novo lead quando o ticket combinar com as palavras-chave configuradas ou entrar em uma das filas selecionadas.',
          automationEnabled: 'Automático',
          triggerLabel: 'Disparo',
          triggers: {
            accept_ticket: 'Ao aceitar ticket',
            message_received: 'Ao receber mensagem ou entrar na fila',
          },
          triggerHelpers: {
            accept_ticket: 'O lead é criado quando um atendente aceita o ticket.',
            message_received: 'O lead é criado assim que o cliente envia uma palavra-chave ou o ticket entra em uma das filas, antes de alguém aceitar.',
          },
          firstContactRuleLabel: 'Regra de contato',
          firstContactOnly: 'Somente no primeiro ticket do contato',
          allTickets: 'Todos os tickets',
          contactRuleHelper: 'Em todos os casos, não é criado um novo lead se o contato já tiver uma oportunidade aberta neste pipeline.',
          targetStage: 'Stage de entrada',
          defaultProduct: 'Produto/serviço padrão',
          defaultProductHelper: 'Vinculado ao lead criado automaticamente. O preço do produto vira o valor da oportunidade.',
          noDefaultProduct: 'Nenhum',
          funnelAutomationsTitle: 'Automações do funil',
          funnelAutomationsDescription: 'Ações automáticas sobre as oportunidades deste pipeline. Funcionam mesmo com a criação automática desligada.',
          acceptTicketStageId: 'Ao aceitar ticket, mover para',
          closeTicketStageId: 'Ao finalizar ticket, mover para',
          moveStageHelper: 'Move a oportunidade aberta do contato somente para frente no funil.',
          doNotMove: 'Não mover',
          staleFollowUpDays: 'Criar follow-up após dias parada no stage',
          staleFollowUpDaysHelper: 'Cria um follow-up para o responsável quando a oportunidade fica esse número de dias no mesmo stage. Deixe vazio para desativar.',
          inactivityLossDays: 'Marcar como perdida após dias sem resposta',
          inactivityLossDaysHelper: 'Marca como perdida a oportunidade em que o cliente não envia mensagem nesse período. Deixe vazio para desativar.',
          inactivityLossCategory: 'Motivo de perda por inatividade',
          logCustomerMessages: 'Registrar mensagens do cliente na timeline',
          logCustomerMessagesHelper: 'Quando o cliente envia mensagem, registra na timeline da oportunidade aberta (no máximo uma vez por dia) e ela deixa de contar como parada.',
          keywords: 'Palavras-chave',
          keywordsHelper: 'Digite uma palavra e pressione Enter para criar um chip. Clique no x do chip para remover.',
          keywordsPlaceholder: 'Digite e pressione Enter',
          queues: 'Filas',
          queuesHelper: 'Selecione uma ou mais filas. Se o ticket estiver em qualquer uma delas, o lead será criado automaticamente.',
          queuesPlaceholder: 'Selecione as filas',
          saveAutomation: 'Salvar automação',
          lossCategoryDescription: 'Organize os motivos usados quando uma oportunidade é marcada como perdida.',
        },
        conversions: {
          title: 'Dashboard de fluxo comercial CRM',
          subtitle: 'Acompanhe quantas oportunidades foram criadas, ganhas e perdidas para identificar gargalos e oportunidades no funil.',
          alertsTitle: 'Alertas rapidos',
          alertsSubtitle: 'Prioridades para agir assim que o dashboard carregar.',
          allPipelines: 'Todos os pipelines',
          startDate: 'Data inicial',
          endDate: 'Data final',
          granularity: 'Granularidade',
          daily: 'Diário',
          weekly: 'Semanal',
          monthly: 'Mensal',
          day: 'dia',
          days: 'dias',
          hoursShort: 'h',
          minutesShort: 'min',
          chartTitle: 'Evolução do volume de ganhos e perdas',
          pipelineBreakdown: 'Desempenho por pipeline',
          previousPeriodComparison: 'Comparativo com período anterior',
          pipelineByValue: 'Pipeline por valor',
          pipelineOpenTotal: '{{count}} oportunidade(s) aberta(s)',
          downloadCsv: 'Baixar CSV',
          downloadImage: 'Baixar imagem',
          pipelineHealth: 'Saúde do pipeline',
          averageTimeByStage: 'Tempo médio por stage',
          averageTimeByStageDescription: 'Quanto tempo as oportunidades levaram para sair de cada stage (avançar, ganhar ou perder), considerando as saídas no período.',
          stayCount: '{{count}} passagem(ns)',
          averageStageDays: 'Tempo médio',
          openAging: 'Oportunidades paradas',
          staleOver7: 'Paradas +7 dias',
          status: 'Status',
          lossCategoryBreakdown: 'Motivos de perda',
          mainLossReason: 'Motivo principal de perda',
          averageLostTicket: 'Ticket médio perdido',
          stageFunnel: 'Funil por stage',
          share: 'Participação',
          metric: 'Métrica',
          currentPeriod: 'Período atual',
          previousPeriod: 'Período anterior',
          variation: 'Variação',
          emptyChart: 'Nenhum dado encontrado para o período selecionado.',
          emptyBreakdown: 'Nenhum resultado encontrado para os filtros atuais.',
          emptyLosses: 'Nenhuma perda encontrada para o período selecionado.',
          statusOptions: {
            healthy: 'Saudável',
            attention: 'Atenção',
            critical: 'Crítico',
          },
          statusReasons: {
            healthy: 'Status saudável porque o stage está com tempo médio de {{averageStageDays}} e sem sinais críticos.',
            attention: 'Status de atenção porque o stage está com tempo médio de {{averageStageDays}} e {{staleCount}} oportunidade(s) paradas há mais de 7 dias.',
            criticalStageTime: 'Status crítico porque o stage está com tempo médio de {{averageStageDays}} e {{staleCount}} oportunidade(s) já estão paradas há mais de 7 dias.',
            criticalStaleShare: 'Status crítico porque {{staleCount}} de {{openCount}} oportunidade(s) abertas estão paradas há mais de 7 dias. Tempo médio atual: {{averageStageDays}}.',
          },
          funnel: {
            enteredCount: 'Entraram',
            advancedCount: 'Avançaram',
            advancementRate: 'Taxa de avanço',
            winRate: 'Taxa de ganho',
            lossRate: 'Taxa de perda',
          },
          summary: {
            convertedCount: 'Ganhas',
            convertedAmount: 'Valor ganho',
            createdCount: 'Criadas',
            conversionRate: 'Taxa de conversão',
            lostCount: 'Perdidas',
            lostAmount: 'Valor perdido',
            lossRate: 'Taxa de perda',
            openAmount: 'Valor em negociação',
            openCount: 'Oportunidades abertas',
            averageWonTicket: 'Ticket médio',
          },
          sources: {
            auto_stage: 'Stage automático',
            manual_button: 'Botão marcar como ganho',
            lost: 'Marcada como perdida',
            other: 'Origem não mapeada ({{key}})',
          },
        },
      },
      settings: {
        success: 'Configurações salvas com sucesso.',
        title: 'Configurações',
        settings: {
          userCreation: {
            name: 'Criação de usuário',
            options: {
              enabled: 'Ativado',
              disabled: 'Desativado',
            },
          },
          timezone: {
            name: 'Fuso horário',
          },
        },
      },
      messagesList: {
        header: {
          assignedTo: 'Atribuído à:',
          notMessage: 'Não há mensagens neste atendimento.',
          buttons: {
            return: 'Retornar',
            resolve: 'Resolver',
            reopen: 'Reabrir',
            accept: 'Aceitar',
            closeWithoutBot: 'Finalizar sem notificação',
          },
        },
        privateMessage: {
          label: 'Nota privada · {{name}}',
          unknownAuthor: 'Atendente',
          deleted: 'Esta nota foi excluída.',
          options: 'Opções da nota',
        },
      },
      showTicketLogModal: {
        title: {
          header: 'Histórico do Atendimento',
        },
        options: {
          create: 'Criado',
          chatBot: 'Bot',
          queue: 'Fila',
          open: 'Aberto',
          access: 'Acesso',
          transfered: 'Transferido',
          receivedTransfer: 'Recebeu transferência',
          pending: 'Pendente',
          closed: 'Fechado',
          reopen: 'Reaberto',
          redirect: 'Redirecionado',
        },
      },
      frontEndErrors: {
        getUsers: 'Erro ao carregar usuários.',
      },
      allTicket: {
        form: {
          viewTags: 'Visualizar tags',
        },
      },
      messagesInput: {
        placeholderOpen: 'Digite uma mensagem',
        placeholderClosed: 'Reabra ou aceite esse ticket para enviar uma mensagem.',
        signMessage: 'Assinar',
        pendingTicketInfo: 'Este ticket está aguardando. Aceite o ticket para responder as mensagens.',
        privateMode: {
          label: 'Tipo de envio',
          message: 'Mensagem',
          note: 'Nota privada',
          placeholder: 'Escreva uma nota para a equipe…',
          save: 'Salvar nota',
          hint: 'Só a equipe vê esta nota. O cliente não recebe nada no WhatsApp.',
        },
      },
      contactDrawer: {
        header: 'Dados do contato',
        buttons: {
          edit: 'Editar contato',
        },
        block: {
          title: 'Bloqueio',
          blockedLabel: 'Este contato está bloqueado no WhatsApp e não consegue enviar mensagens para a conexão.',
          block: 'Bloquear contato',
          unblock: 'Desbloquear contato',
          confirmBlockTitle: 'Bloquear este contato?',
          confirmBlockMessage: 'O número será bloqueado no WhatsApp da conexão deste ticket e deixará de enviar mensagens para ela. Você pode desbloquear depois por este painel.',
          confirmUnblockTitle: 'Desbloquear este contato?',
          confirmUnblockMessage: 'O número voltará a conseguir enviar mensagens para a conexão deste ticket.',
          blocked: 'Contato bloqueado.',
          unblocked: 'Contato desbloqueado.',
        },
        crm: {
          title: 'CRM',
          inCrm: 'Este contato já possui oportunidade aberta no CRM.',
          notInCrm: 'Este contato ainda não possui oportunidade aberta no CRM.',
          moveAction: 'Mover no CRM',
          addAction: 'Adicionar ao CRM',
          transferAction: 'Copiar / mover',
          openCount: '{{count}} oportunidades abertas no CRM',
        },
        extraInfo: 'Outras informações',
        group: {
          title: 'Integrantes do grupo',
          refresh: 'Atualizar',
          add: 'Adicionar membros',
          remove: 'Remover',
          empty: 'Nenhum integrante encontrado para este grupo.',
          missingIdentifiers: 'Não foi possível gerenciar os participantes deste contato.',
          count: 'Integrantes: {{count}}',
          unknown: 'Desconhecido',
          roles: {
            admin: 'Admin',
            superAdmin: 'Super admin',
          },
          modal: {
            title: 'Adicionar integrantes ao grupo',
            description: 'Pesquise e selecione contatos existentes para adicionar a este grupo.',
            searchLabel: 'Contatos',
            searchPlaceholder: 'Digite para buscar contatos',
            loading: 'Carregando contatos...',
            noOptions: 'Nenhum contato encontrado',
            cancel: 'Cancelar',
            confirm: 'Adicionar membros',
          },
          toasts: {
            missingInformation: 'Informações insuficientes para gerenciar este grupo.',
            noContacts: 'Selecione ao menos um contato para continuar.',
            addSuccess: 'Participantes adicionados com sucesso!',
            removeSuccess: 'Participante removido com sucesso!',
          },
          confirmation: {
            title: 'Remover participante',
            message: 'Deseja realmente remover {{name}} deste grupo?',
          },
        },
      },
      fileModal: {
        title: {
          add: 'Adicionar lista de arquivos',
          edit: 'Editar lista de arquivos',
        },
        buttons: {
          okAdd: 'Salvar',
          okEdit: 'Editar',
          cancel: 'Cancelar',
          fileOptions: 'Adicionar arquivo',
        },
        form: {
          name: 'Nome da lista de arquivos',
          message: 'Detalhes da lista',
          fileOptions: 'Lista de arquivos',
          extraName: 'Mensagem para enviar com arquivo',
          extraValue: 'Valor da opção',
        },
        success: 'Lista de arquivos salva com sucesso!',
      },
      ticketOptionsMenu: {
        addToCrm: 'Adicionar ao CRM',
        schedule: 'Agendamento',
        delete: 'Deletar',
        transfer: 'Transferir',
        closeWithoutBot: 'Finalizar sem mensagem do bot',
        closeWithoutBotModal: {
          title: 'Finalizar sem mensagem do bot',
          message: 'O ticket será finalizado sem enviar a mensagem de encerramento ao cliente.',
        },
        registerAppointment: 'Observações do Contato',
        appointmentsModal: {
          title: 'Observações do Contato',
          textarea: 'Observação',
          placeholder: 'Insira aqui a informação que deseja registrar',
        },
        confirmationModal: {
          title: 'Deletar o ticket',
          titleFrom: 'do contato ',
          message: 'Atenção! Todas as mensagens relacionadas ao ticket serão perdidas.',
        },
        buttons: {
          delete: 'Excluir',
          cancel: 'Cancelar',
        },
      },
      confirmationModal: {
        buttons: {
          confirm: 'Ok',
          cancel: 'Cancelar',
        },
      },
      messageOptionsMenu: {
        delete: 'Deletar',
        reactionSuccess: 'Reação add',
        reply: 'Responder',
        edit: 'Editar Mensagem',
        forward: 'Encaminhar',
        toForward: 'Encaminhar',
        react: 'Reagir',
        confirmationModal: {
          title: 'Apagar mensagem?',
          message: 'Esta ação não pode ser revertida.',
        },
        privateMessage: {
          edit: 'Editar nota',
          delete: 'Excluir nota',
          confirmationModal: {
            title: 'Excluir nota privada?',
            message: 'A nota deixará de aparecer para toda a equipe. Esta ação não pode ser revertida.',
          },
        },
      },
      backendErrors: {
        ERR_APPOINTMENT_NOTIFICATIONS_DISABLED: 'Escolha antes uma conexão WhatsApp nas configurações de notificações.',
        ERR_APPOINTMENT_NOTIFICATION_FAILED: 'O WhatsApp não conseguiu enviar a notificação. Verifique a conexão.',
        ERR_APPOINTMENT_NO_ACTIVE_CONVERSATION: 'Não há conversa aberta com o cliente.',
        ERR_APPOINTMENT_TEMPLATE_INVALID: 'Uma das mensagens é inválida ou grande demais.',
        ERR_APPOINTMENT_AI_NOT_CONFIGURED: 'A IA não está configurada neste ambiente.',
        ERR_APPOINTMENT_AI_FAILED: 'Não foi possível consultar a IA.',
        ERR_GOOGLE_CALENDAR_NOT_CONFIGURED: 'A integração com o Google Agenda não está configurada.',
        ERR_GOOGLE_CALENDAR_NOT_CONNECTED: 'O Google Agenda não está conectado.',
        ERR_GOOGLE_CALENDAR_ACCESS_REVOKED: 'O acesso ao Google foi revogado ou expirou. Reconecte para continuar sincronizando.',
        ERR_GOOGLE_CALENDAR_NOT_FOUND: 'Agenda não encontrada ou sem permissão de edição.',
        ERR_GOOGLE_CALENDAR_INVALID_STATE: 'O link de conexão expirou. Tente novamente.',
        ERR_GOOGLE_CALENDAR_NO_REFRESH_TOKEN: 'O Google não concedeu o acesso offline. Tente novamente.',
        ERR_GOOGLE_CALENDAR_SCOPES_MISSING: 'Conceda todas as permissões solicitadas para conectar.',
        ERR_GOOGLE_CALENDAR_SYNC_FAILED: 'Não foi possível falar com o Google Agenda. Tente novamente.',
        ERR_GOOGLE_EVENT_REMOVED: 'O evento foi excluído no Google Agenda. Tente novamente para criá-lo de novo.',
        ERR_APPOINTMENT_CALENDAR_BLOCKED: 'Este horário está ocupado no Google Agenda. Escolha outro horário.',
        ERR_APPOINTMENT_NOT_FOUND: 'Agendamento não encontrado.',
        ERR_APPOINTMENT_TYPE_NOT_FOUND: 'Tipo de atendimento não encontrado ou inativo.',
        ERR_APPOINTMENT_FIELD_NOT_FOUND: 'Campo não encontrado.',
        ERR_APPOINTMENT_TIME_CONFLICT: 'Este horário já está ocupado. Escolha outro horário.',
        ERR_APPOINTMENT_CLOSED: 'Este agendamento já foi encerrado e não pode ser alterado.',
        ERR_APPOINTMENT_NOT_CANCELLED: 'Só um agendamento cancelado pode ser reativado.',
        ERR_APPOINTMENT_REACTIVATE_PAST: 'O horário deste agendamento já passou. Crie um novo agendamento.',
        ERR_APPOINTMENT_TYPE_IN_USE: 'Este tipo é usado em agendamentos e não pode ser excluído. Desative-o.',
        ERR_APPOINTMENT_PROFESSIONAL_NOT_FOUND: 'Profissional não encontrado ou inativo.',
        ERR_APPOINTMENT_PROFESSIONAL_REQUIRED: 'Escolha o profissional do agendamento.',
        ERR_APPOINTMENT_PROFESSIONAL_IN_USE: 'Este profissional já tem agendamentos e não pode ser excluído. Desative-o.',
        ERR_APPOINTMENT_PROFESSIONAL_NOT_LINKED: 'Seu usuário não está vinculado a um profissional.',
        ERR_APPOINTMENT_PROFESSIONAL_USER_NOT_FOUND: 'Usuário de acesso não encontrado nesta empresa.',
        ERR_APPOINTMENT_PROFESSIONAL_USER_IN_USE: 'Este usuário já está vinculado a outro profissional.',
        ERR_APPOINTMENT_PROFESSIONAL_INVALID_SCHEDULE: 'Confira os horários de funcionamento do profissional.',
        ERR_APPOINTMENT_PROFESSIONAL_UNCHANGED: 'O agendamento já está atribuído a esse profissional.',
        ERR_APPOINTMENT_IN_THE_PAST: 'Escolha uma data e horário futuros.',
        ERR_APPOINTMENT_INVALID_DATE: 'Data inválida.',
        ERR_APPOINTMENT_INVALID_RANGE: 'Intervalo de datas inválido.',
        ERR_APPOINTMENT_RANGE_TOO_LARGE: 'O intervalo de datas é grande demais.',
        ERR_APPOINTMENT_FIELD_REQUIRED: 'Preencha todos os campos obrigatórios.',
        ERR_APPOINTMENT_FIELD_INVALID: 'Um dos campos tem um valor inválido.',
        ERR_APPOINTMENT_FIELD_OPTIONS_REQUIRED: 'Adicione ao menos uma opção à lista.',
        ERR_FISCAL_DATA_REQUIRED: 'Informe a razão social e o endereço da empresa antes de pagar.',
        ERR_PRIVATE_MESSAGE_BODY_REQUIRED: 'Escreva o texto da nota antes de salvar.',
        ERR_PRIVATE_MESSAGE_ACTION_NOT_ALLOWED: 'Esta ação não está disponível para notas privadas.',
        ERR_NO_MESSAGE_FOUND: 'Mensagem não encontrada.',
        ERR_CRM_STAGE_HAS_OPPORTUNITIES: 'Esse stage possui oportunidades vinculadas e não pode ser excluído.',
        ERR_CRM_STAGE_ORDER_REQUIRED: 'Informe a nova ordem dos stages.',
        ERR_CRM_STAGE_ORDER_INVALID: 'A ordem dos stages informada é inválida.',
        ERR_CRM_AUTO_WON_STAGE_ALREADY_EXISTS: 'Já existe um stage final configurado nesse pipeline.',
        ERR_NO_CRM_TAG_FOUND: 'Tag comercial não encontrada.',
        ERR_CRM_TAG_NAME_REQUIRED: 'Informe o texto da tag.',
        ERR_CRM_TAG_ALREADY_EXISTS: 'Já existe uma tag comercial com esse texto.',
        ERR_CRM_TAG_IN_USE: 'Essa tag está vinculada a oportunidades e não pode ser excluída.',
        ERR_CRM_TAG_REQUIRED: 'Selecione uma tag.',
        ERR_NO_CRM_PRODUCT_FOUND: 'Produto/serviço não encontrado.',
        ERR_CRM_PRODUCT_NAME_REQUIRED: 'Informe o nome do produto/serviço.',
        ERR_CRM_PRODUCT_INVALID_PRICE: 'Informe um preço válido.',
        ERR_CRM_PRODUCT_ALREADY_EXISTS: 'Já existe um produto/serviço com esse nome.',
        ERR_CRM_PRODUCT_IN_USE: 'Esse produto/serviço está vinculado a oportunidades. Desative-o em vez de excluir.',
        ERR_CRM_PRODUCT_INACTIVE: 'Esse produto/serviço está inativo.',
        ERR_CRM_TRANSFER_MODE_INVALID: 'Escolha copiar ou mover a oportunidade.',
        ERR_CRM_TRANSFER_TARGET_REQUIRED: 'Selecione o pipeline e o stage de destino.',
        ERR_CRM_TRANSFER_SAME_STAGE: 'A oportunidade já está nesse stage.',
        ERR_NO_OTHER_WHATSAPP: 'Deve haver pelo menos um WhatsApp padrão.',
        ERR_NO_DEF_WAPP_FOUND: 'Nenhum WhatsApp padrão encontrado. Verifique a página de conexões.',
        ERR_WAPP_NOT_INITIALIZED: 'Esta sessão do WhatsApp não foi inicializada. Verifique a página de conexões.',
        ERR_WAPP_CHECK_CONTACT: 'Não foi possível verificar o contato do WhatsApp. Verifique a página de conexões',
        ERR_WAPP_INVALID_CONTACT: 'Este não é um número de Whatsapp válido.',
        ERR_WAPP_DOWNLOAD_MEDIA: 'Não foi possível baixar mídia do WhatsApp. Verifique a página de conexões.',
        ERR_WAPP_PAIRING_CODE_NOT_GENERATED: 'Não foi possível gerar o código de conexão. Aguarde alguns segundos e tente novamente.',
        ERR_INVALID_CREDENTIALS: 'Erro de autenticação. Por favor, tente novamente.',
        ERR_SENDING_WAPP_MSG: 'Erro ao enviar mensagem do WhatsApp. Verifique a página de conexões.',
        ERR_DELETE_WAPP_MSG: 'Não foi possível excluir a mensagem do WhatsApp.',
        ERR_OTHER_OPEN_TICKET: 'Já existe um tíquete aberto para este contato.',
        ERR_OTHER_OPEN_TICKET_DETAILS: 'Fila {{queue}} • Usuário {{user}}.',
        ERR_SESSION_EXPIRED: 'Sessão expirada. Por favor entre.',
        ERR_USER_CREATION_DISABLED: 'A criação do usuário foi desabilitada pelo administrador.',
        ERR_NO_PERMISSION: 'Você não tem permissão para acessar este recurso.',
        NO_PARTICIPANT_NUMBERS: 'Nenhum participante informado.',
        NO_VALID_PARTICIPANTS: 'Não foi possível interpretar os participantes informados.',
        ERR_ADD_GROUP_PARTICIPANT: 'Erro ao adicionar participantes ao grupo.',
        ERR_REMOVE_GROUP_PARTICIPANT: 'Erro ao remover participantes do grupo.',
        ERR_DUPLICATED_CONTACT: 'Já existe um contato com este número.',
        ERR_NO_SETTING_FOUND: 'Nenhuma configuração encontrada com este ID.',
        ERR_NO_CONTACT_FOUND: 'Nenhum contato encontrado com este ID.',
        ERR_CANNOT_BLOCK_GROUP_CONTACT: 'Não é possível bloquear um grupo.',
        ERR_NO_TICKET_FOUND: 'Nenhum tíquete encontrado com este ID.',
        ERR_NO_USER_FOUND: 'Nenhum usuário encontrado com este ID.',
        ERR_NO_WAPP_FOUND: 'Nenhum WhatsApp encontrado com este ID.',
        ERR_USER_WHATSAPP_NOT_ALLOWED: 'Você não tem acesso a esta conexão.',
        ERR_USER_DEFAULT_WHATSAPP_NOT_ALLOWED: 'A conexão padrão precisa estar entre as conexões permitidas.',
        ERR_CREATING_MESSAGE: 'Erro ao criar mensagem no banco de dados.',
        ERR_CREATING_TICKET: 'Erro ao criar tíquete no banco de dados.',
        ERR_FETCH_WAPP_MSG: 'Erro ao buscar a mensagem no WhtasApp, talvez ela seja muito antiga.',
        ERR_QUEUE_COLOR_ALREADY_EXISTS: 'Esta cor já está em uso, escolha outra.',
        ERR_WAPP_GREETING_REQUIRED: 'A mensagem de saudação é obrigatório quando há mais de uma fila.',
        ERR_WAPP_AGENT_TEST_REQUIRES_QUEUE: 'Quando o agente da conexão está em modo de teste, a conexão precisa ter pelo menos uma fila para o fluxo normal do chatbot.',
        ERR_CHECK_NUMBER: 'Número inválido. Verifique o número e tente novamente.',
        ERR_COMPANY_DOCUMENT_ALREADY_EXISTS: 'Já existe uma empresa cadastrada com estes dados. Por favor, verifique os dados informados.',
        ERR_COMPANY_EMAIL_ALREADY_EXISTS: 'Este e-mail já está em uso. Entre ou recupere a senha.',
        ERR_WEAK_PASSWORD: 'Use 8 caracteres ou mais, com letra maiúscula, minúscula e número.',
        ERR_INVALID_RESET_TOKEN: 'Código inválido ou expirado. Confira o código ou peça um novo.',
        ERR_TOO_MANY_REQUESTS: 'Muitas tentativas. Aguarde alguns minutos e tente de novo.',
        ERR_SIGNUP_DISABLED: 'Novos cadastros estão fechados no momento.',
        ERR_TERMS_NOT_ACCEPTED: 'Aceite os termos para criar a conta.',
        ERR_PLAN_NOT_AVAILABLE: 'Este plano não está disponível para cadastro. Escolha outro.',
        ERR_QUICKMESSAGE_NAME_ALREADY_EXISTS: 'Já existe uma Resposta Rápida com este mesmo nome.',
      },
      companyExpiredModal: {
        title: 'Empresa Expirada',
        message: 'Regularize os pagamentos para voltar a utilizar o sistema.',
      },
    },
  },
}

export { messages }
